(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      /* R3-16: a rotation changes the slab (56 vs 64 header, 28 vs 38 announcement) without crossing
         the 990 breakpoint, so the slab height is re-read on orientation change and on resize. */
      window.matchMedia('(orientation: landscape)').addEventListener('change', this.setHeaderHeight.bind(this));
      window.addEventListener('resize', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      /* P28 lane E (STICKY SYSTEM step 8): the store runs `always` (header-group.json): hide, reveal and reset return at once and
         nothing reads `scrolled-past-header` (svnty-tokens.css), so Trade's unthrottled, non-passive scroll handler is not attached
         at all; the headstack (svnty-headstack.js) is the header's one scroll owner. Any other sticky type keeps Trade's handler. */
      if (!this.headerIsAlwaysSticky) window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      /* R3-16 / R142: `--header-height` is the HEADER only. `--svnty-headstack-h` (the VISIBLE slab: bar +
         header at rest, header alone once the bar is parked) is published by assets/svnty-headstack.js. */
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["svnty-contact"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-svnty-contact]');
  if (!root) return;
  var form = root.querySelector('[data-svnty-ct-form]');
  var sent = root.querySelector('[data-svnty-ct-sent]');
  var DRAFT = 'svnty:contact:draft:v2';
  /* P22-34 (walk B, K1 K2): a sent note's facts, this tab only, two hours: the sent card prints them again after a refresh, and
     the form opened after it (Back, a second visit) starts clean, so the same note is never posted twice */
  var SENT = 'svnty:contact:sent:v1', SENT_MS = 2 * 60 * 60 * 1000;
  function sentRecord() { try { var k = JSON.parse(sessionStorage.getItem(SENT) || 'null'); if (k && Array.isArray(k.rows)) k.rows = k.rows.filter(function (r) { return r && r[0] !== 'Reply to'; }); return k && Array.isArray(k.rows) && Date.now() - (+k.t || 0) < SENT_MS ? k : null; } catch (e) { return null; } }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- THE SENT STATE: what we received, from the draft kept before the post ---------- */
  if (sent) {
    try {
      var d = JSON.parse(sessionStorage.getItem(DRAFT) || 'null');
      var facts = sent.querySelector('[data-svnty-ct-sent-facts]');
      var rows = [];
      if (d) {
        if (d.email) rows.push(['Reply to', d.email]);
        if (d.mode === 'order' && d.order) rows.push(['Order', '#' + d.order]);
        if (d.pieces) rows.push(['Pieces', d.pieces]);
        if (d.topic) rows.push(['About', d.topic]);
        if (d.body) rows.push(['Your note', d.body.length > 240 ? d.body.slice(0, 240) + '…' : d.body]);
        /* P35-2: the record a refresh reprints keeps no email; the reply address shows on this first card only */
        try { sessionStorage.setItem(SENT, JSON.stringify({ t: Date.now(), rows: rows.filter(function (r) { return r[0] !== 'Reply to'; }) })); } catch (e) {}
      } else {
        var kept = sentRecord(); if (kept) rows = kept.rows;
      }
      if (facts) {
        if (rows.length) {
          facts.innerHTML = rows.map(function (r) { return '<dt></dt><dd></dd>'; }).join('');
          var dts = facts.querySelectorAll('dt'), dds = facts.querySelectorAll('dd');
          rows.forEach(function (r, i) { dts[i].textContent = r[0]; dds[i].textContent = r[1]; });
          facts.hidden = false;
        }
      }
      sessionStorage.removeItem(DRAFT);
    } catch (e) {}
    try { sent.focus({ preventScroll: true }); } catch (e) {}
    try { sent.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' }); } catch (e) {}
    return;
  }
  if (!form) return;
  /* P22-34 (walk B, K1): after a sent note and before a new draft, the form is clean, whatever the browser restored */
  var wipe = function () { try { form.reset(); } catch (e) {} return true; };
  var startClean = function () { if (!sentRecord()) return false; try { if (sessionStorage.getItem(DRAFT)) return false; } catch (e) { return false; } return wipe(); };
  /* Part42 FIX (the round-1 refuter's older defect B): Chromium refills a finished note AFTER the load event on a Back that misses the cache
     (a non-persisted pageshow), when the draft this page's own start wrote already stands, so the clean start is judged again at every
     pageshow: a page that started clean and that she has not touched (no input or change event; a browser's restore raises none) is wiped
     again, the same finished state */
  var cleanAtStart = startClean(), fresh = true;
  form.addEventListener('input', function () { fresh = false; }, true);
  form.addEventListener('change', function () { fresh = false; }, true);
  function restoredByBrowser() {
    for (var i = 0; i < form.elements.length; i += 1) {
      var el = form.elements[i], t = el.type;
      if (t === 'radio' || t === 'checkbox') { if (el.checked !== el.defaultChecked) return true; }
      else if ((t === 'text' || t === 'email' || t === 'textarea') && el.value !== el.defaultValue) return true;
    }
    return false;
  }
  /* Part42: a Back out of the cache clears the sending state, and the note id is the stored draft's (none = a new one: a finished note's
     id is never reused) */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { endSending(); readDraftIds(); if (startClean()) settleClean(); return; }
    if (!cleanAtStart || !sentRecord()) return;
    var again = function () { if (fresh && restoredByBrowser()) { wipe(); settleClean(); } };
    again(); window.setTimeout(again, 0);   /* and a restore that lands late */
  });

  var $ = function (sel) { return root.querySelector(sel); };
  var modeInputs = root.querySelectorAll('[data-svnty-ct-mode-input]');
  var modeField = $('[data-svnty-ct-mode-field]');
  var orderBox = $('[data-svnty-ct-order]');
  var orderInput = $('[data-svnty-ct-order-input]');
  var contactInput = $('[data-svnty-ct-contact-input]');
  var findBtn = $('[data-svnty-ct-find]');
  var findMsg = $('[data-svnty-ct-find-msg]');
  var piecesBox = $('[data-svnty-ct-pieces]');
  var pieceList = $('[data-svnty-ct-piece-list]');
  var piecesField = $('[data-svnty-ct-pieces-field]');
  var topicItems = root.querySelectorAll('[data-svnty-ct-topic-item]');
  var topicInputs = root.querySelectorAll('[data-svnty-ct-topic-input]');
  var topicField = $('[data-svnty-ct-topic-field]');
  var topicHint = $('[data-svnty-ct-topic-hint]');
  var guard = $('[data-svnty-ct-guard]');
  var guardText = $('[data-svnty-ct-guard-text]');
  var guardLink = $('[data-svnty-ct-guard-link]');
  var nameInput = $('[data-svnty-ct-name]');
  var nameErr = $('[data-svnty-ct-name-err]');
  var emailInput = $('[data-svnty-ct-email]');
  var emailErr = $('[data-svnty-ct-email-err]');
  var body = $('[data-svnty-ct-body]');
  var bodyErr = $('[data-svnty-ct-body-err]');
  var count = $('[data-svnty-ct-count]');
  var pageField = $('[data-svnty-ct-page-field]');
  var sendBtn = $('[data-svnty-ct-send]');
  var slot = $('[data-svnty-turnstile]');
  var laneUrl = root.getAttribute('data-lane-url') || '';
  var laneLive = root.getAttribute('data-lane-live') === 'true';
  var siteKey = (root.getAttribute('data-sitekey') || '').trim();
  var minChars = Math.max(1, parseInt(root.getAttribute('data-min-chars') || '12', 10));
  var doors = {
    returns: { text: root.getAttribute('data-guard-returns-text') || 'Returns, exchanges, refunds and cancellations start on their own page, with your real order. If that page cannot do what you need, such as a change to a parcel already with Bosta, write to onlineshop@svntyeg.com.', href: root.getAttribute('data-guard-returns-href') || '/pages/returns-exchanges', cta: 'Open Returns and exchanges' },
    track:   { text: root.getAttribute('data-guard-track-text') || 'Track your order shows where your parcel is, live. A delivery in progress is not handled from this form.', href: root.getAttribute('data-guard-track-href') || '/pages/track-your-order', cta: 'Open Track your order' }
  };
  var GUARD_WORDS = {
    returns: /\b(return|returns|returning|exchange|exchanges|swap|refund|refunds|cancel|cancell?ation)\b|استرجاع|ارجاع|إرجاع|تبديل|استبدال|الغاء|إلغاء|استرداد/i,
    track:   /\b(track|tracking|where is my (order|parcel|package)|hasn'?t arrived|not arrived|delivery status|out for delivery|awb)\b|فين الاوردر|فين الطلب|تتبع|وصل|توصيل الاوردر/i
  };
  var mode = 'question';
  var sending = false, sendTimer = 0, noteId = '', sentHash = '', copied = '', copiedOk = '';   /* Part42 THE ONE SEND (below) + THE NOTE'S ID and its words' hash (the draft) + the id whose desk copy left */
  var found = null;   /* { order, pieces:[{title, variantTitle, quantity, handle, image}] } */

  function setMsg(el, text, kind) { if (!el) return; el.textContent = text || ''; el.classList.toggle('is-bad', kind === 'bad'); el.classList.toggle('is-good', kind === 'good'); }

  /* ---------- THE WAY ---------- */
  function applyMode() {
    var isOrder = mode === 'order';
    if (orderBox) orderBox.hidden = !isOrder;
    if (modeField) modeField.value = isOrder ? 'About my order' : 'A question';
    Array.prototype.forEach.call(topicItems, function (it) {
      var modes = (it.getAttribute('data-modes') || 'question order').split(/\s+/);
      var show = modes.indexOf(mode) >= 0;
      it.hidden = !show;
      if (!show) { var inp = it.querySelector('input'); if (inp && inp.checked) { inp.checked = false; } }
    });
    syncTopic();
    if (isOrder && laneLive && siteKey) tsLoad();
    saveDraft();
  }
  Array.prototype.forEach.call(modeInputs, function (r) {
    r.addEventListener('change', function () { if (r.checked) { mode = r.value; applyMode(); } });
  });

  /* ---------- THE TOPIC + THE GUARD ---------- */
  function checkedTopic() { for (var i = 0; i < topicInputs.length; i += 1) { if (topicInputs[i].checked) return topicInputs[i]; } return null; }
  function showGuard(kind) {
    if (!guard) return;
    var d = doors[kind];
    guard.hidden = false;
    guardText.textContent = d.text;
    guardLink.textContent = d.cta;
    guardLink.href = d.href;
    if (sendBtn) sendBtn.disabled = true;
  }
  function hideGuard() { if (guard) guard.hidden = true; if (sendBtn && !sending) sendBtn.disabled = false; }   /* Part42: never while sending */
  function textGuard() {
    var t = (body && body.value) || '';
    if (GUARD_WORDS.returns.test(t)) return 'returns';
    if (GUARD_WORDS.track.test(t)) return 'track';
    return '';
  }
  function syncTopic() {
    var t = checkedTopic();
    if (topicField) topicField.value = t ? t.value : '';
    var g = (t && t.getAttribute('data-guard')) || '';
    if (!g) g = textGuard();
    if (g) showGuard(g); else hideGuard();
    if (topicHint) { var hint = t && t.closest('[data-svnty-ct-topic-item]').getAttribute('data-hint'); topicHint.hidden = !hint; topicHint.textContent = hint || ''; }
  }
  Array.prototype.forEach.call(topicInputs, function (r) { r.addEventListener('change', function () { syncTopic(); saveDraft(); }); });

  /* ---------- THE MESSAGE ---------- */
  function syncCount() {
    if (!body || !count) return;
    var n = body.value.length, max = parseInt(body.getAttribute('maxlength') || '2000', 10);
    count.textContent = n + ' / ' + max;
    if (n >= minChars) { body.classList.remove('is-bad'); body.removeAttribute('aria-invalid'); if (bodyErr) bodyErr.hidden = true; }
  }
  if (body) {
    var bt = null;
    body.addEventListener('input', function () { syncCount(); window.clearTimeout(bt); bt = window.setTimeout(function () { syncTopic(); saveDraft(); }, 160); });
  }
  if (emailInput) emailInput.addEventListener('input', function () { emailInput.classList.remove('is-bad'); emailInput.removeAttribute('aria-invalid'); if (emailErr) emailErr.hidden = true; saveDraft(); });
  if (nameInput) nameInput.addEventListener('input', function () { nameInput.classList.remove('is-bad'); nameInput.removeAttribute('aria-invalid'); if (nameErr) nameErr.hidden = true; saveDraft(); });

  /* ---------- THE ORDER (the tracking lane, read-only) ---------- */
  var TS = { widget: null, ready: null };
  function tsLoad() {
    if (!laneLive || !siteKey || !slot) return Promise.resolve(null);
    if (TS.ready) return TS.ready;
    TS.ready = new Promise(function (resolve) {
      if (window.turnstile) return resolve(window.turnstile);
      var sc = document.createElement('script');
      sc.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'; sc.async = true; sc.defer = true;
      sc.onload = function () { resolve(window.turnstile || null); };
      sc.onerror = function () { resolve(null); };
      document.head.appendChild(sc);
    }).then(function (ts) {
      if (!ts) return null;
      try {
        slot.hidden = false;
        TS.widget = ts.render(slot, { sitekey: siteKey, action: 'track', appearance: 'interaction-only', size: 'flexible', theme: 'light', 'refresh-expired': 'auto',
          'before-interactive-callback': function () { slot.classList.add('is-asking'); },
          'after-interactive-callback': function () { slot.classList.remove('is-asking'); } });   /* R392: the widget's own asking state */
      } catch (e) { return null; }
      return ts;
    });
    return TS.ready;
  }
  function tsToken() {
    return tsLoad().then(function (ts) {
      if (!ts || TS.widget == null) return '';
      /* the check usually answers within a second or two; if it has not by four, one reset wakes it (measured in Edge:
         the first render sat silent, the reset answered at once); at ten seconds (P17-18: the tracking page's wait, not
         fourteen) the lane is asked without it, and a send without a token is never repeated */
      return new Promise(function (resolve) {
        var t0 = Date.now(), kicked = false;
        (function wait() {
          var v = ''; try { v = ts.getResponse(TS.widget) || ''; } catch (e) {}
          if (v) return resolve(v);
          var dt = Date.now() - t0, asking = tsAsking();   /* R392: no kick and no 10 s give-up while she is answering the box */
          if (!kicked && dt > 4000 && !asking) { kicked = true; tsReset(); }
          if (dt > (asking ? 120000 : 10000)) return resolve('');
          setTimeout(wait, 150);
        })();
      });
    });
  }
  function tsReset() { try { if (window.turnstile && TS.widget != null) window.turnstile.reset(TS.widget); } catch (e) {} }
  /* R392 THE PAGES WAIT FOR HER TICK (SVNTY_Design_Part31_CC2): Cloudflare is asking her (the widget's own
     before-interactive state) and the box is on screen (the seat has height), and no token has come: the page waits for her
     tick, up to two minutes, and never resets the box she is answering. No box (the invisible check, a seat with no height)
     keeps the old guards. */
  function tsAsking() { return !!slot && slot.classList.contains('is-asking') && slot.offsetHeight > 0; }

  function normDigits(s) { return String(s || '').replace(/[٠-٩]/g, function (c) { return String(c.charCodeAt(0) - 0x0660); }).replace(/[۰-۹]/g, function (c) { return String(c.charCodeAt(0) - 0x06F0); }); }
  /* an optional leading "#" and every space (the invisible direction marks an Arabic keypad adds included) fall away */
  var ORDER_SPACE = /[\s\u061C\u200B-\u200F\u202A-\u202E\u2066-\u2069]/g;
  function cleanOrder(v) { return normDigits(v).replace(ORDER_SPACE, '').replace(/^[#\uFF03]/, '').slice(0, 20); }
  function cleanContact(v) { return normDigits(v).trim().slice(0, 80); }
  /* P17-18 (the eye pass's P1-2): the lane's own tests, run here first (svnty-core: an order number is 3 to 10 digits; a phone
     9 to 15 digits; an email has its shape) */
  function orderOk(v) { return /^\d{3,10}$/.test(v); }
  function contactOk(v) {
    v = normDigits(v).trim();
    if (v.indexOf('@') > -1) return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
    var n = v.replace(/\D/g, '').length;
    return /^[+\d\s().-]+$/.test(v) && n >= 9 && n <= 15;
  }

  function renderPieces(pieces) {
    if (!pieceList || !piecesBox) return;
    pieceList.innerHTML = '';
    if (!pieces || !pieces.length) { piecesBox.hidden = true; return; }
    pieces.slice(0, 12).forEach(function (p, i) {
      var li = document.createElement('li');
      var lab = document.createElement('label'); lab.className = 'svnty-ct__piece';
      var inp = document.createElement('input'); inp.type = 'checkbox'; inp.className = 'svnty-ct__piece-input'; inp.value = String(i);
      var img = document.createElement('img'); img.className = 'svnty-ct__piece-img'; img.alt = ''; img.loading = 'lazy'; img.width = 44; img.height = 55;
      if (p.image) img.src = p.image; else img.removeAttribute('src');
      var tx = document.createElement('span'); tx.className = 'svnty-ct__piece-text';
      var t = document.createElement('span'); t.className = 'svnty-ct__piece-t'; t.textContent = p.title || p.handle || 'Piece';
      var v = document.createElement('span'); v.className = 'svnty-ct__piece-v'; v.textContent = [p.variantTitle, p.quantity > 1 ? '× ' + p.quantity : ''].filter(Boolean).join(' · ');
      var ck = document.createElement('span'); ck.className = 'svnty-ct__piece-check'; ck.setAttribute('aria-hidden', 'true'); ck.innerHTML = (window.SVNTY && SVNTY.iconHTML) ? SVNTY.iconHTML('check', 10, 1.5) : '';  /* THE ICON LAW (D11-3): the family's tick */
      tx.appendChild(t); if (v.textContent) tx.appendChild(v);
      lab.appendChild(inp); if (p.image) lab.appendChild(img); lab.appendChild(tx); lab.appendChild(ck);
      inp.addEventListener('change', function () { syncPieces(); saveDraft(); });
      li.appendChild(lab); pieceList.appendChild(li);
    });
    piecesBox.hidden = false;
    syncPieces();
  }
  function syncPieces() {
    if (!piecesField || !found) return;
    var picks = [];
    Array.prototype.forEach.call(pieceList.querySelectorAll('input:checked'), function (inp) {
      var p = found.pieces[parseInt(inp.value, 10)];
      if (p) picks.push((p.title || p.handle) + (p.variantTitle ? ' (' + p.variantTitle + ')' : ''));
    });
    piecesField.value = picks.join('; ');
  }
  function pieceImage(handle, variant) {
    /* the card-fetch section names the piece and its picture (the dev proxy refuses /products/x.js) */
    if (!handle) return Promise.resolve(null);
    var url = '/products/' + encodeURIComponent(handle) + '?section_id=svnty-card-fetch' + (variant ? '&variant=' + encodeURIComponent(variant) : '');
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      if (!html) return null;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var img = doc.querySelector('img[src], img[srcset]');
      var src = img ? (img.getAttribute('src') || (img.getAttribute('srcset') || '').split(',')[0].trim().split(' ')[0]) : '';
      return src ? src.replace(/^\/\//, 'https://') : null;
    }).catch(function () { return null; });
  }

  /* ---------- THE FIND ROW (P17-18, the eye pass's P1-2: the returns and tracking pages' P17-1 behavior) ----------
     Judged before anything leaves, each refusal under its own cell (the cells' error lines are printed empty with the page, so a
     press never meets a DOM write: THE iOS TAP LAW). One silent retry only for a real token the lane refused; a check that gave
     no token is never sent again. Every answer has its own words: 404 is the only "no order matches"; 400 names the cell;
     403 is the quick check; 429 the lock, in the lane's own seconds (retry_after in the body or the header, the longer); a
     timeout, a 5xx or a body that is not the contract is the lookup not answering. */
  var FIND_WORDS = {
    orderEmpty: 'Enter your order number.',
    order: 'Order numbers are 3 to 10 digits, as in your confirmation email.',
    contactEmpty: 'Enter the phone or email you used at checkout.',
    contact: 'Enter the phone number or the email address you used at checkout, as in your confirmation email.',
    none: 'No order matches that number and contact. Check the confirmation email: the number as it appears there, and the phone or email you used at checkout.',
    human: 'The quick check did not complete. Try again in a moment, or send the note with your order number and we find it ourselves.',
    down: 'The lookup did not answer. Send the note with your order number and we find it ourselves.'
  };
  function lockWords(secs) {
    var wait = secs > 3600 ? 'Try again tomorrow.' : secs >= 90 ? 'Try again in about ' + (secs >= 3300 ? 'an hour' : Math.ceil(secs / 60) + ' minutes') + '.' : 'Try again in a minute.';
    return 'Too many lookups for now. ' + wait + ' Other phones and emails are not affected. You can also send the note with your order number and we find it ourselves.';
  }
  var cellErr = { order: $('[data-svnty-ct-order-err]'), contact: $('[data-svnty-ct-contact-err]') };
  var cellEl = { order: orderInput, contact: contactInput };
  function setCellErr(k, msg) {
    var e = cellErr[k], c = cellEl[k];
    if (!e || !c) { setMsg(findMsg, msg, 'bad'); return; }
    e.textContent = msg; e.hidden = false;
    c.classList.add('is-bad'); c.setAttribute('aria-invalid', 'true');
    try { c.focus(); } catch (x) {}
  }
  function clearCellErr(k) {
    var e = cellErr[k], c = cellEl[k];
    if (e && !e.hidden) { e.textContent = ''; e.hidden = true; }
    if (c && c.getAttribute('aria-invalid') === 'true') { c.classList.remove('is-bad'); c.removeAttribute('aria-invalid'); }
  }
  ['order', 'contact'].forEach(function (k) { if (cellEl[k]) cellEl[k].addEventListener('input', function () { clearCellErr(k); }); });

  var inflight = false;
  function findOrder() {
    if (inflight || sending) return;
    clearCellErr('order'); clearCellErr('contact');
    var order = cleanOrder(orderInput && orderInput.value);
    var contact = cleanContact(contactInput && contactInput.value);
    if (!order) { setMsg(findMsg, '', ''); setCellErr('order', FIND_WORDS.orderEmpty); return; }
    if (!orderOk(order)) { setMsg(findMsg, '', ''); setCellErr('order', FIND_WORDS.order); return; }
    if (!contact) { setMsg(findMsg, '', ''); setCellErr('contact', FIND_WORDS.contactEmpty); return; }
    if (!contactOk(contact)) { setMsg(findMsg, '', ''); setCellErr('contact', FIND_WORDS.contact); return; }
    if (orderInput) orderInput.value = order;
    if (!laneLive) { setMsg(findMsg, 'The order lookup is being switched on. Send the note with the order number and we find it ourselves.', ''); return; }
    inflight = true; findBtn.setAttribute('aria-busy', 'true'); setMsg(findMsg, 'Looking…', '');
    var tries = 0;
    function done() { inflight = false; findBtn.removeAttribute('aria-busy'); }
    function fail(msg) { done(); found = null; renderPieces([]); setMsg(findMsg, msg, 'bad'); }
    (function attempt() {
      tries += 1;
      var tokened = false, timer = 0, ctl = typeof AbortController === 'function' ? new AbortController() : null;
      tsToken().then(function (token) {
        tokened = !!token;
        var b = { order: order, contact: contact };
        if (siteKey) b.turnstile = token || '';
        var o = { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(b) };
        if (ctl) { o.signal = ctl.signal; timer = setTimeout(function () { ctl.abort(); }, 12000); }
        return fetch(laneUrl, o);
      }).then(function (r) {
        clearTimeout(timer);
        // a real token the lane refused earns one fresh one; a check that never gave a token cannot pass on a second send
        if (r.status === 403 && tries < 2 && tokened) { tsReset(); attempt(); return; }
        return r.json().catch(function () { return {}; }).then(function (j) {
          j = j && typeof j === 'object' ? j : {};
          if (r.ok && j.ok === true) {
            done();
            var pieces = Array.isArray(j.pieces) ? j.pieces.filter(function (x) { return x && (x.title || x.handle); }).map(function (x) {
              return { title: String(x.title || ''), handle: String(x.handle || ''), variantTitle: String(x.variantTitle || ''), variant: x.variant || x.variantId || '', quantity: Math.max(1, Math.floor(Number(x.quantity) || 1)), image: x.image || '' };
            }) : [];
            found = { order: j.order ? String(j.order).replace(/^#/, '') : order, pieces: pieces };
            if (orderInput && found.order) orderInput.value = found.order;
            setMsg(findMsg, 'Found order #' + found.order + (pieces.length ? ', ' + pieces.length + (pieces.length === 1 ? ' piece.' : ' pieces.') : '.'), 'good');
            renderPieces(pieces);
            Promise.all(pieces.map(function (p) { return p.image ? Promise.resolve(p.image) : pieceImage(p.handle, p.variant); })).then(function (imgs) {
              imgs.forEach(function (src, i) { if (src) { pieces[i].image = src; var im = pieceList.querySelectorAll('.svnty-ct__piece')[i]; if (im) { var tag = im.querySelector('img'); if (!tag) { tag = document.createElement('img'); tag.className = 'svnty-ct__piece-img'; tag.alt = ''; tag.width = 44; tag.height = 55; im.insertBefore(tag, im.querySelector('.svnty-ct__piece-text')); } tag.src = src; } } });
            });
            saveDraft();
            return;
          }
          if (r.status === 404) { fail(FIND_WORDS.none); return; }
          if (r.status === 400) {
            done(); found = null; renderPieces([]); setMsg(findMsg, '', '');
            if (j.field === 'contact') setCellErr('contact', FIND_WORDS.contact); else setCellErr('order', FIND_WORDS.order);
            return;
          }
          if (r.status === 403) { fail(FIND_WORDS.human); return; }
          if (r.status === 429) {
            var hdr = 0; try { hdr = parseInt(r.headers.get('retry-after'), 10) || 0; } catch (x) {}
            fail(lockWords(Math.max(Number(j.retry_after) || 0, hdr))); return;
          }
          fail(FIND_WORDS.down);
        });
      }).catch(function () { clearTimeout(timer); fail(FIND_WORDS.down); });
    })();
  }
  if (findBtn) findBtn.addEventListener('click', findOrder);
  [orderInput, contactInput].forEach(function (el) { if (el) el.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); findOrder(); } }); });

  /* ---------- THE DRAFT (this tab only) ---------- */
  /* Part42 THE NOTE'S ID: minted with the draft, in the intake's own format (rd_ + 24 hex: the returns desk's requestId(), svnty-public's
     RID_RE), sent as the desk copy's requestId so a copy sent again files once; a new id only after the finished state (the sent card
     removes the draft) */
  var NOTE_ID = /^rd_[0-9a-f]{24}$/, NOTE_HASH = /^[0-9a-f]{8}$/;
  /* P2-3 (round 1) + P2-1 (round 2): what was sent under the id is kept as a hash beside it, the copy (name, email, the way, the order,
     the topic, the pieces, the note; each trimmed): anything corrected after a return mints a new id and a new copy, the same note keeps
     it (djb2, 8 hex). Never the checkout contact (P35-2: the draft carries it in no form, and a 32-bit hash of a phone is brute-forced
     from the other fields), so a corrected contact alone keeps the id and sends no new copy (rare, accepted by the lead) */
  function copyHash(c) {
    var t = JSON.stringify([c.name, c.email, c.mode, c.order, c.category, c.pieces, c.body].map(function (v) { return String(v == null ? '' : v).trim(); }));
    var h = 5381; for (var i = 0; i < t.length; i += 1) h = ((h << 5) + h + t.charCodeAt(i)) | 0;
    return ('0000000' + (h >>> 0).toString(16)).slice(-8);
  }
  function mintNoteId() {
    var bytes = new Uint8Array(12);
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') window.crypto.getRandomValues(bytes);
    else for (var i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
    return 'rd_' + Array.prototype.map.call(bytes, function (byte) { var hex = byte.toString(16); return hex.length === 1 ? '0' + hex : hex; }).join('');
  }
  function ensureNoteId() { if (!NOTE_ID.test(noteId)) noteId = mintNoteId(); return noteId; }
  function readDraftIds() {
    var d = null; try { d = JSON.parse(sessionStorage.getItem(DRAFT) || 'null'); } catch (e) {}
    noteId = d && typeof d.noteId === 'string' && NOTE_ID.test(d.noteId) ? d.noteId : '';
    sentHash = noteId && typeof d.sentHash === 'string' && NOTE_HASH.test(d.sentHash) ? d.sentHash : '';
    copied = copiedOk = noteId && d.copied === noteId ? noteId : '';
  }
  function saveDraft() {
    try {
      sessionStorage.setItem(DRAFT, JSON.stringify({
        mode: mode, order: orderInput ? cleanOrder(orderInput.value) : '',   // P35-2: never the checkout contact
        topic: topicField ? topicField.value : '', pieces: piecesField ? piecesField.value : '',
        name: nameInput ? nameInput.value : '', email: emailInput ? emailInput.value : '', body: body ? body.value : '',
        noteId: ensureNoteId(), sentHash: sentHash, copied: copiedOk && copiedOk === noteId ? copiedOk : ''   /* P3-4 (round 2) + round 3: the id whose desk copy the desk answered 2xx */
      }));
    } catch (e) {}
  }
  function loadDraft() {
    var d = null; try { d = JSON.parse(sessionStorage.getItem(DRAFT) || 'null'); } catch (e) {}
    if (!d) return;
    if ('contact' in d) { delete d.contact; try { sessionStorage.setItem(DRAFT, JSON.stringify(d)); } catch (e) {} }   // P35-2: a draft written before the pass loses it
    if (typeof d.noteId === 'string' && NOTE_ID.test(d.noteId)) { noteId = d.noteId; sentHash = typeof d.sentHash === 'string' && NOTE_HASH.test(d.sentHash) ? d.sentHash : ''; copied = copiedOk = d.copied === d.noteId ? d.noteId : ''; }   /* Part42: the draft's own id (and its words' hash) survives a refresh */
    if (d.mode === 'order') { Array.prototype.forEach.call(modeInputs, function (r) { r.checked = r.value === 'order'; }); mode = 'order'; }
    if (orderInput && d.order && !orderInput.value) orderInput.value = d.order;
    if (nameInput && d.name && !nameInput.value) nameInput.value = d.name;
    if (emailInput && d.email && !emailInput.value) emailInput.value = d.email;
    if (body && d.body && !body.value) body.value = d.body;
    if (d.topic) Array.prototype.forEach.call(topicInputs, function (r) { if (r.value === d.topic) r.checked = true; });
  }

  /* ---------- THE DEEP LINK: ?piece=<handle> (from a product page's "ask about this piece") ---------- */
  function prefill() {
    var q; try { q = new URLSearchParams(location.search); } catch (e) { return; }
    var handle = (q.get('piece') || '').trim();
    var topic = (q.get('topic') || '').trim();
    if (pageField) pageField.value = document.referrer && /^https?:\/\/[^/]+\/products\//.test(document.referrer) ? document.referrer.split('?')[0] : '';
    if (topic) Array.prototype.forEach.call(topicInputs, function (r) { if (r.value.toLowerCase() === topic.toLowerCase()) r.checked = true; });
    if (handle && /^[a-z0-9][a-z0-9-]*$/i.test(handle) && body && !body.value) {
      fetch('/products/' + encodeURIComponent(handle) + '?section_id=svnty-card-fetch', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        var doc = new DOMParser().parseFromString(html || '', 'text/html');
        var t = doc.querySelector('[data-svnty-name], .card__heading, h3, h2');
        var title = t ? t.textContent.trim() : handle.replace(/-/g, ' ');
        if (!body.value) { fresh = false; body.value = 'About the ' + title + ': '; syncCount(); saveDraft(); }
      }).catch(function () {});
    }
  }

  /* ---------- THE SEND ---------- */
  /* Part42 THE ONE SEND (live 25 Oct 11:29Z: ten taps in 36 s while Shopify's captcha held the post, ten copies at the desk). The first
     valid submit sets the sending state, the returns desk's chain (the form's flag and aria-busy; Send aria-disabled with its word, so
     focus stays and a screen reader hears it; the fields read-only, so the desk copy and the post carry the same words), only once the
     submit event fires, never on the press (THE iOS TAP LAW); a submit while sending is refused whole.
     THE FIRST LISTENER (the round-1 refuter): Shopify's captcha iife listens on the form, its bootstrap on the document; the iife cancels
     the event, asks hCaptcha, then posts with the browser's own form.submit() (no submit event), so a refusal that only cancels is
     ignored and the post still leaves. This listener sits on the document in the capture phase, ahead of both in any load order, and every
     refusal (a cell, the returns guard, sending) cancels AND stops the event: a refused form never posts.
     THE END OF SENDING is hCaptcha's own answer, not a clock: the check the iife starts inside this very submit is watched through a
     pass-through on hcaptcha.execute (the same promise handed back, nothing else touched). Closed, expired or failed = Send back at once;
     pending = still sending (never two checks in flight); passed = the post is leaving. A submit the captcha held with no check started
     (the form not bound yet, the iife's own 250 ms latch) ends the state at once. A check that cannot be watched falls back to the
     challenge frame: seen open, then shut with no new token in the form = closed; a new token = the pass.
     THE 60 s CLOCK (round 2) is the last resort and releases one thing only: a check still pending whose challenge was never seen open
     (a stalled getcaptcha never settles, and hcaptcha.reset does not settle it). It never releases an open challenge, a check whose
     challenge was seen open (a closed one rejects at once, so a pending one is her answer being checked), or a post that left (a pass,
     or the browser's own post when the store runs no captcha): a second tap there could post twice. A Back out of the cache clears the
     state (the pageshow above). */
  var SEND_SAFETY = 60000;
  var sendIdle = sendBtn ? sendBtn.textContent : '';
  var sendBusy = (sendBtn && sendBtn.getAttribute('data-busy-label')) || 'Sending';
  var locked = [nameInput, emailInput, body, orderInput, contactInput].filter(function (el) { return !!el; });
  var hcCall = null, hcArmed = false, frameTimer = 0, sendLeft = false;   /* sendLeft: the post left (a pass, the browser's own post) */
  var HC_FRAME = 'iframe[src*="hcaptcha"][src*="frame=challenge"]';
  /* open = a real size, not parked above the page (hCaptcha parks a shut challenge at top -10000px), and no hidden, none or clear step
     from the frame up to the body */
  function frameOpen() {
    var fs = document.querySelectorAll(HC_FRAME);
    for (var i = 0; i < fs.length; i += 1) {
      var r = fs[i].getBoundingClientRect(), shown = r.width > 1 && r.height > 1 && r.bottom + (window.pageYOffset || 0) > 0;
      for (var n = fs[i]; shown && n && n !== document.body && window.getComputedStyle; n = n.parentElement) {
        var st = window.getComputedStyle(n);
        if (st.display === 'none' || st.visibility === 'hidden' || parseFloat(st.opacity) < 0.05) shown = false;
      }
      if (shown) return true;
    }
    return false;
  }
  function tokenNow() { var v = ''; Array.prototype.forEach.call(form.querySelectorAll('[name="h-captcha-response"]'), function (el) { v += el.value || ''; }); return v; }
  function armSafety() {
    window.clearTimeout(sendTimer);
    sendTimer = window.setTimeout(function () {
      if (sendLeft || frameOpen() || (hcCall && hcCall.seen)) { armSafety(); return; }   /* round 2: P3-1 a pending check never seen open goes; P3-2 never after the post left */
      endSending();
    }, SEND_SAFETY);
  }
  function beginSending() {
    sending = true; sendLeft = false; form.dataset.svntyCtSending = '1'; form.setAttribute('aria-busy', 'true');
    if (sendBtn) { sendBtn.setAttribute('aria-disabled', 'true'); sendBtn.textContent = sendBusy; }
    locked.forEach(function (el) { el.readOnly = true; });
    armSafety();
  }
  function endSending() {
    window.clearTimeout(sendTimer); sendTimer = 0; window.clearInterval(frameTimer); frameTimer = 0; hcCall = null; hcArmed = false; sendLeft = false;
    if (!sending) return;
    sending = false; form.dataset.svntyCtSending = '0'; form.removeAttribute('aria-busy');
    locked.forEach(function (el) { el.readOnly = false; });
    if (sendBtn) { sendBtn.removeAttribute('aria-disabled'); sendBtn.textContent = sendIdle; sendBtn.disabled = !!guard && !guard.hidden; }   /* the guard keeps its hold */
  }
  /* the pass-through, put in once: a call made while this form's submit is being dispatched is this note's check */
  function hcWatch() {
    var hc = window.hcaptcha;
    if (!hc || typeof hc.execute !== 'function') return false;
    if (hc.execute.svntyCt) return true;
    var run = hc.execute;
    var seen = function () {
      var p = run.apply(this, arguments);
      try { if (hcArmed && sending && p && typeof p.then === 'function') hcHeld(p); } catch (e) {}
      return p;
    };
    seen.svntyCt = true;
    try { hc.execute = seen; } catch (e) {}
    return hc.execute === seen;
  }
  function hcHeld(p) {
    var c = hcCall = { done: '', seen: false };
    var look = window.setInterval(function () { if (hcCall !== c || c.done) { window.clearInterval(look); return; } if (frameOpen()) c.seen = true; }, 250);   /* the clock's "seen open" */
    p.then(function () { if (hcCall === c) { c.done = 'pass'; sendLeft = true; } },
      function () { if (hcCall === c) { c.done = 'fail'; endSending(); } });   /* challenge-closed, -expired, a network or rate refusal */
  }
  /* the fallback: a new passcode in the form = the pass (the post left; 20+ characters: a real one is a long P1_ token, while a refused
     check was seen leaving a 15-character value there in the real hCaptcha); the challenge frame (hCaptcha's own iframe, #frame=challenge)
     seen open, then shut for 750 ms with no new passcode = closed */
  function frameWatch() {
    var seenOpen = false, shut = 0, before = tokenNow();
    window.clearInterval(frameTimer);
    frameTimer = window.setInterval(function () {
      if (!sending) { window.clearInterval(frameTimer); frameTimer = 0; return; }
      var tok = tokenNow();
      if (tok.length >= 20 && tok !== before) { sendLeft = true; window.clearInterval(frameTimer); frameTimer = 0; return; }
      if (frameOpen()) { seenOpen = true; shut = 0; return; }
      if (!seenOpen || (shut += 1) < 3) return;
      window.clearInterval(frameTimer); frameTimer = 0;
      endSending();
    }, 250);
  }
  function afterSubmit(e, watched) {
    hcArmed = false;
    if (!sending || hcCall) return;   /* hCaptcha's own promise answers */
    if (!e.defaultPrevented) { sendLeft = true; return; }   /* no captcha on the form: the browser posts it, the post left */
    if (watched || !form.hasAttribute('data-hcaptcha-bound')) { endSending(); return; }   /* held, no check started: nothing leaves */
    frameWatch();
  }
  function refuse(e) { e.preventDefault(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); }
  /* the radios and the pieces cannot be read-only: a press on one while sending is cancelled in its click (never on the press) */
  form.addEventListener('click', function (e) { var t = e.target; if (sending && t && (t.type === 'radio' || t.type === 'checkbox')) e.preventDefault(); }, true);
  document.addEventListener('submit', function (e) {
    if (e.target !== form) return;
    /* every submit while sending is refused (round 3: today's iife v1.5.3 turns any submit after the pass into a second check and a second
       post); a future Shopify script that posts through requestSubmit() needs a pass-through here gated on the pass and e.submitter === null */
    if (sending) { refuse(e); return; }
    var ok = true;
    if (nameInput && !nameInput.value.trim()) { ok = false; nameInput.classList.add('is-bad'); nameInput.setAttribute('aria-invalid', 'true'); if (nameErr) nameErr.hidden = false; }
    if (emailInput && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(emailInput.value.trim())) { ok = false; emailInput.classList.add('is-bad'); emailInput.setAttribute('aria-invalid', 'true'); if (emailErr) emailErr.hidden = false; }
    if (body && body.value.trim().length < minChars) { ok = false; body.classList.add('is-bad'); body.setAttribute('aria-invalid', 'true'); if (bodyErr) bodyErr.hidden = false; }
    var g = (checkedTopic() && checkedTopic().getAttribute('data-guard')) || textGuard();
    if (g) { ok = false; showGuard(g); }
    if (!ok) { refuse(e); var first = form.querySelector('.is-bad') || guard; if (first) { try { first.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' }); } catch (err) {} if (first.focus) first.focus({ preventScroll: true }); } return; }
    if (mode === 'question' && orderInput) orderInput.value = '';   /* a question carries no order */
    syncTopic(); syncPieces();
    var copy = { source: 'contact', mode: mode, category: topicField ? topicField.value : '', name: nameInput ? nameInput.value : '', email: emailInput ? emailInput.value : '', order: mode === 'order' && orderInput ? cleanOrder(orderInput.value) : '', contact: mode === 'order' && contactInput ? cleanContact(contactInput.value) : '', pieces: piecesField ? piecesField.value : '', subject: 'Contact · ' + ((topicField && topicField.value) || 'Something else'), body: body ? body.value : '', page: pageField ? pageField.value : '' };
    var sig = copyHash(copy);
    if (sentHash && sentHash !== sig) noteId = mintNoteId();   /* P2-3 + P2-1: anything corrected after a return is a new note, a new id */
    var id = ensureNoteId(); sentHash = sig;
    /* THE NOTE LANE: a copy for the desk, fire-and-forget, SVNTY's own proxy only (Law 0); the native post is the answer. One copy per
       note id: on this page a copy in flight or answered blocks another (a send again after a closed challenge sends none unless the
       first failed); the draft records it only once the desk answered 2xx (round 3), so a refresh never sends a delivered copy again and
       a copy still in flight or refused at a refresh is sent again. The id rides as requestId; a copy that does arrive twice is deduped by the desk on content within
       ten minutes from 0.36.1 (the same words, email and order in one ten-minute window are one row), not by the id */
    var lane = (form.getAttribute('data-svnty-note-lane') || '').trim(), sendCopy = !!lane && copied !== id;
    if (sendCopy) copied = id;
    saveDraft();
    beginSending();
    var watched = hcWatch(); hcArmed = true; hcCall = null;
    window.setTimeout(function () { afterSubmit(e, watched); }, 0);
    if (!sendCopy) return;
    try {
      copy.requestId = id;
      var unsent = function () { if (copied === id) copied = ''; };
      fetch(lane, { method: 'POST', credentials: 'same-origin', keepalive: true, headers: { 'content-type': 'text/plain' }, body: JSON.stringify(copy) })
        .then(function (r) { if (!r.ok) { unsent(); return; } copiedOk = id; saveDraft(); }, unsent);
    } catch (err) { if (copied === id) copied = ''; }
  }, true);

  /* the clean start again (a Back after the sent card, or a cached page): the way follows the reset radios, no found order, a new id */
  function settleClean() {
    var m = 'question';
    Array.prototype.forEach.call(modeInputs, function (r) { if (r.checked) m = r.value; });
    mode = m; found = null; renderPieces([]); if (piecesField) piecesField.value = ''; setMsg(findMsg, '', '');
    noteId = ''; sentHash = ''; copied = ''; copiedOk = '';
    applyMode(); syncCount(); prefill();
  }

  loadDraft();
  applyMode();
  syncCount();
  prefill();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["svnty-delivery"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var root = document.querySelector('[data-svnty-delivery]');
  if (!root) return;
  var q = function (sel) { return root.querySelector(sel); };
  var input = q('[data-dl-input]'), clearBtn = q('[data-dl-clear]'), opts = q('[data-dl-opts]'), quick = q('[data-dl-quick]');
  var answer = q('[data-dl-answer]'), stateEl = q('[data-dl-state]'), placeEl = q('[data-dl-place]'), zoneEl = q('[data-dl-zone]'), costEl = q('[data-dl-cost]'), timeEl = q('[data-dl-time]');
  var idleLine = stateEl.textContent, cursor = -1;
  /* P22-22 HER ANSWER (svnty-never-lose-what-she-typed): the place she picked or the text she typed, this tab, 2 hours */
  var KEY = 'svnty:dl-find', LIFE = 7200000;
  function keep(v) { try { if (v && (v.q || v.g)) { v.t = Date.now(); sessionStorage.setItem(KEY, JSON.stringify(v)); } else sessionStorage.removeItem(KEY); } catch (e) {} }
  function kept() { try { var v = JSON.parse(sessionStorage.getItem(KEY) || 'null'); return v && Date.now() - (v.t || 0) < LIFE ? v : null; } catch (e) { return null; } }
  /* the 27 governorates as people type them, in English and Arabic, with the aliases the zone notes use */
  var GOV = [
    ['Cairo', 'القاهرة', ['cairo', 'el qahira', 'al qahira', 'qahira', 'masr', 'helwan', 'new cairo', 'nasr city', 'maadi', 'heliopolis', 'القاهرة الجديدة', 'حلوان', 'مصر', 'مدينة نصر', 'المعادي']],
    ['Giza', 'الجيزة', ['giza', 'gizeh', 'el giza', '6th of october', 'october', 'sheikh zayed', 'zayed', 'haram', 'dokki', 'mohandessin', '6 اكتوبر', 'أكتوبر', 'اكتوبر', 'الشيخ زايد', 'زايد', 'الهرم', 'الدقي', 'المهندسين']],
    ['Alexandria', 'الإسكندرية', ['alexandria', 'alex', 'iskandariya', 'اسكندرية', 'الاسكندرية', 'إسكندرية']],
    ['Beheira', 'البحيرة', ['beheira', 'behera', 'buhayra', 'damanhour', 'البحيره', 'دمنهور']],
    ['Qalyubia', 'القليوبية', ['qalyubia', 'qalioubia', 'kalyoubia', 'qalyub', 'banha', 'benha', 'obour', 'al obour', 'shubra el kheima', 'القليوبيه', 'بنها', 'العبور', 'شبرا الخيمة']],
    ['Sharqia', 'الشرقية', ['sharqia', 'al sharqia', 'sharkia', 'sharkeya', 'zagazig', 'tenth of ramadan', '10th of ramadan', 'الشرقيه', 'الزقازيق', 'العاشر من رمضان']],
    ['Dakahlia', 'الدقهلية', ['dakahlia', 'dakahleya', 'mansoura', 'الدقهليه', 'المنصورة']],
    ['Damietta', 'دمياط', ['damietta', 'domiat', 'دمياط الجديدة']],
    ['Gharbia', 'الغربية', ['gharbia', 'gharbeya', 'tanta', 'mahalla', 'الغربيه', 'طنطا', 'المحلة']],
    ['Ismailia', 'الإسماعيلية', ['ismailia', 'ismaileya', 'الاسماعيلية', 'اسماعيلية']],
    ['Kafr El Sheikh', 'كفر الشيخ', ['kafr el sheikh', 'kafr elsheikh', 'kafr al sheikh', 'kafr el-sheikh', 'كفر الشيخ']],
    ['Monufia', 'المنوفية', ['monufia', 'menoufia', 'menofia', 'shebin', 'shibin el kom', 'المنوفيه', 'شبين الكوم']],
    ['Port Said', 'بورسعيد', ['port said', 'portsaid', 'bur said', 'بور سعيد']],
    ['Suez', 'السويس', ['suez', 'ain sokhna', 'sokhna', 'العين السخنة', 'السخنة']],
    ['Asyut', 'أسيوط', ['asyut', 'assiut', 'assuit', 'اسيوط']],
    ['Beni Suef', 'بني سويف', ['beni suef', 'bani suef', 'benisuef', 'بنى سويف']],
    ['Faiyum', 'الفيوم', ['faiyum', 'fayoum', 'fayum', 'el fayoum', 'فيوم']],
    ['Minya', 'المنيا', ['minya', 'menia', 'el minya', 'المنيا']],
    ['Sohag', 'سوهاج', ['sohag', 'suhag', 'سوهاج']],
    ['Aswan', 'أسوان', ['aswan', 'اسوان']],
    ['Luxor', 'الأقصر', ['luxor', 'louxor', 'الاقصر', 'اقصر']],
    ['Matrouh', 'مطروح', ['matrouh', 'matrouh', 'marsa matrouh', 'north coast', 'sahel', 'el alamein', 'alamein', 'مرسى مطروح', 'الساحل', 'العلمين']],
    ['Qena', 'قنا', ['qena', 'kena', 'قنا']],
    ['Red Sea', 'البحر الأحمر', ['red sea', 'hurghada', 'gouna', 'el gouna', 'safaga', 'marsa alam', 'البحر الاحمر', 'الغردقة', 'الجونة', 'سفاجا', 'مرسى علم']],
    ['New Valley', 'الوادي الجديد', ['new valley', 'wadi el gedid', 'kharga', 'الوادى الجديد', 'الخارجة']],
    ['North Sinai', 'شمال سيناء', ['north sinai', 'arish', 'el arish', 'شمال سينا', 'العريش']],
    ['South Sinai', 'جنوب سيناء', ['south sinai', 'sharm', 'sharm el sheikh', 'dahab', 'nuweiba', 'جنوب سينا', 'شرم الشيخ', 'شرم', 'دهب', 'نويبع']]
  ];
  /* the zones: the editor's own blocks; a governorate belongs to the zone whose note names it */
  var rows = Array.prototype.slice.call(root.querySelectorAll('[data-dl-zone-row]'));
  var zones = rows.map(function (r) { return { el: r, area: r.getAttribute('data-area') || '', note: r.getAttribute('data-note') || '', time: r.getAttribute('data-time') || '', cost: r.getAttribute('data-cost') || '', free: /^free$/i.test((r.getAttribute('data-cost') || '').trim()) }; });
  function norm(s) { return String(s || '').toLowerCase().replace(/[ً-ْـ]/g, '').replace(/[إأآ]/g, 'ا').replace(/ة/g, 'ه').replace(/ى/g, 'ي').replace(/[^a-z0-9؀-ۿ]+/g, ' ').trim(); }
  function zoneOf(gov) {
    var n = norm(gov[0]), keys = [n].concat(gov[2].map(norm));
    for (var i = 0; i < zones.length; i++) {
      if (zones[i].free) continue;
      var note = norm(zones[i].note + ' ' + zones[i].area);
      for (var k = 0; k < keys.length; k++) { if (keys[k] && (' ' + note + ' ').indexOf(' ' + keys[k] + ' ') > -1) return zones[i]; }
    }
    return null;
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function matches(text) {
    var n = norm(text); if (!n) return [];
    return GOV.filter(function (g) {
      var keys = [norm(g[0]), norm(g[1])].concat(g[2].map(norm));
      return keys.some(function (k) { return k.indexOf(n) === 0 || k.split(' ').some(function (w) { return w.indexOf(n) === 0; }); });
    }).slice(0, 7);
  }
  function render(text) {
    clearBtn.hidden = !text; cursor = -1;
    /* P17-27 (eye pass R2 B P2-1): an edit after a pick takes the last place's answer away until a place is picked again */
    if (!answer.hidden && String(text || '').trim() !== (input.dataset.picked || '')) {
      answer.hidden = true; input.dataset.picked = '';
      rows.forEach(function (r) { r.classList.remove('is-hit'); });
      Array.prototype.forEach.call(quick.children, function (c) { c.classList.remove('is-on'); c.setAttribute('aria-pressed', 'false'); });
    }
    keep({ q: String(text || ''), g: input.dataset.picked || '' });
    var list = matches(text);
    if (!list.length) {
      opts.innerHTML = ''; opts.hidden = true; input.setAttribute('aria-expanded', 'false');
      if (norm(text)) { stateEl.textContent = 'No governorate called “' + text.trim() + '”. Try the quick picks.'; stateEl.hidden = false; }
      else { stateEl.textContent = idleLine; stateEl.hidden = !answer.hidden; }
      return;
    }
    opts.innerHTML = list.map(function (g, i) { return '<li role="presentation"><button type="button" class="svnty-dl__opt" role="option" aria-selected="false" id="SvntyDlOpt' + i + '" data-gov="' + esc(g[0]) + '"><span>' + esc(g[0]) + '</span><span class="svnty-dl__opt-ar" lang="ar">' + esc(g[1]) + '</span></button></li>'; }).join('');
    opts.hidden = false; input.setAttribute('aria-expanded', 'true'); stateEl.hidden = true;
  }
  function pick(name) {
    var gov = GOV.filter(function (g) { return g[0] === name; })[0]; if (!gov) return;
    var z = zoneOf(gov);
    opts.hidden = true; opts.innerHTML = ''; input.setAttribute('aria-expanded', 'false');
    input.value = gov[0]; input.dataset.picked = gov[0]; clearBtn.hidden = false;
    keep({ q: gov[0], g: gov[0] });
    rows.forEach(function (r) { r.classList.remove('is-hit'); });
    Array.prototype.forEach.call(quick.children, function (c) { var on = c.getAttribute('data-gov') === gov[0]; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    if (!z) { answer.hidden = true; stateEl.textContent = 'We could not place ' + gov[0] + ' in a zone yet. Write to us and we will tell you the fee.'; stateEl.hidden = false; return; }
    /* the Arabic name in its own run, never broken across lines (P3-4) */
    var ar = document.createElement('span'); ar.className = 'svnty-dl__answer-ar'; ar.lang = 'ar'; ar.dir = 'rtl'; ar.textContent = gov[1];
    placeEl.textContent = gov[0] + ' · '; placeEl.appendChild(ar); zoneEl.textContent = z.area; costEl.textContent = z.cost; timeEl.textContent = z.time;
    answer.hidden = false; stateEl.hidden = true; z.el.classList.add('is-hit');
  }
  var timer = null;
  input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(function () { render(input.value); }, 60); });
  input.addEventListener('keydown', function (e) {
    var o = opts.hidden ? [] : opts.querySelectorAll('.svnty-dl__opt');
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      if (!o.length) return; e.preventDefault();
      cursor = e.key === 'ArrowDown' ? Math.min(o.length - 1, cursor + 1) : Math.max(0, cursor - 1);
      Array.prototype.forEach.call(o, function (b, i) { b.setAttribute('aria-selected', i === cursor ? 'true' : 'false'); });
      input.setAttribute('aria-activedescendant', o[cursor].id);
    } else if (e.key === 'Enter') { if (!o.length) return; e.preventDefault(); pick(o[cursor > -1 ? cursor : 0].getAttribute('data-gov')); }
    else if (e.key === 'Escape') { input.value = ''; render(''); }
  });
  clearBtn.addEventListener('click', function () { input.value = ''; input.dataset.picked = ''; answer.hidden = true; rows.forEach(function (r) { r.classList.remove('is-hit'); }); Array.prototype.forEach.call(quick.children, function (c) { c.classList.remove('is-on'); c.setAttribute('aria-pressed', 'false'); }); render(''); input.focus({ preventScroll: true }); });
  opts.addEventListener('click', function (e) { var b = e.target.closest('.svnty-dl__opt'); if (b) pick(b.getAttribute('data-gov')); });
  /* the quick picks: the three most asked, then the rest of the map by name */
  var QUICK = ['Cairo', 'Giza', 'Alexandria', 'Qalyubia', 'Sharqia', 'Dakahlia', 'Red Sea'];
  quick.innerHTML = QUICK.map(function (n) { return '<button type="button" class="svnty-dl__chip" data-gov="' + esc(n) + '" aria-pressed="false">' + esc(n) + '</button>'; }).join('');
  quick.addEventListener('click', function (e) { var b = e.target.closest('.svnty-dl__chip'); if (b) pick(b.getAttribute('data-gov')); });
  /* P22-22: a reload, a Back or a Forward brings her answer back, quietly (no focus, no scroll); a fresh visit opens clean */
  var navType = '';
  try { navType = ((performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {}).type || ''; } catch (e) {}
  if (navType === 'reload' || navType === 'back_forward') {
    var k = kept();
    if (k && k.g) pick(k.g);
    else if (k && k.q) { input.value = k.q; render(k.q); }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["svnty-gift-card"] && !Shopify.designMode) return;
  try {
    
/* THE AMOUNTS + YOUR AMOUNT + WHO IS IT FOR + SEND ON + THE BUY + THE GIFT BAR (the section's whole behaviour; multi-instance,
   re-render safe). THE iOS TAP LAW: nothing is written to the page on a press; every choice lands on `click`. */
(function () {
  var fmt = function (n) { return Number(n || 0).toLocaleString('en-US'); };
  var money = function (n) { return 'EGP ' + fmt(n); };
  var cartAddUrl = function () {
    try { if (typeof Theme !== 'undefined' && Theme && Theme.routes && Theme.routes.cart_add_url) return Theme.routes.cart_add_url; } catch (e) {}
    return '/cart/add.js';
  };
  var sectionIds = function () {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (n) { if (n.dataset.sectionId) ids.push(n.dataset.sectionId); });
    return ids;
  };
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var isoDay = function (d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); };
  var dayAt = function (offset) { var d = new Date(); d.setHours(0, 0, 0, 0); d.setDate(d.getDate() + offset); return d; };
  var parseDay = function (s) { var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(s || '')); if (!m) return null; var d = new Date(+m[1], +m[2] - 1, +m[3]); d.setHours(0, 0, 0, 0); return d; };
  var SEND_MAX = 90;   /* Shopify schedules a gift card up to 90 days ahead; iOS ignores a date field's min / max, so the script clamps */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var setup = function (root) {
    if (root.dataset.giftBound) return;
    root.dataset.giftBound = '1';
    var $ = function (s) { return root.querySelector(s); };
    var out = $('[data-gift-amount]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-gift-chip]'));
    var customChip = $('[data-gift-custom]');
    var rise = $('[data-gift-rise]');
    var input = $('[data-gift-input]');
    var help = $('[data-gift-help]');
    var customNote = $('[data-gift-custom-note]');
    var field = input ? input.closest('.svnty-gift__custom-field') : null;
    var MIN = input ? parseInt(input.dataset.min, 10) || 0 : 0;
    var MAX = input ? parseInt(input.dataset.max, 10) || 0 : 0;
    var STEP = input ? parseInt(input.dataset.step, 10) || 1 : 1;
    var helpDefault = help ? help.textContent : '';
    var rangeNote = customNote ? customNote.textContent : '';
    var amount = null;
    var customOn = false;

    /* THE GIFT BAR: the amount and "For {name} · From {name}", crossfaded only while the bar is shown. P26-1: svnty-bars.js
       moves the bar into the header's slab (THE SLAB MOUNT). P26 (refuter P2-1): the section is asked FIRST: at a load and at an
       editor re-render this init runs before the hoist, so the bar is still here; by id first, a re-render found the OLD bar
       still hoisted in the header (two elements share the id, the header first in tree order) and wired a bar about to be
       dropped. The id is only the fallback for an init that runs after the hoist. */
    var bar = root.querySelector('[data-giftbar]') || document.getElementById('svnty-giftbar-' + root.dataset.giftSection);
    var inBar = function (s) { return bar ? bar.querySelector(s) : null; };
    var barAmount = inBar('[data-giftbar-amount]'), barFor = inBar('[data-giftbar-for]');
    /* P26 (refuter P3-1): the caps line is built of one span per name (+ the dot between), each truncating on its own, so a
       long For name never hides the From; the line's textContent stays "For Zezo · From Abdul" (the compare below). */
    var put = function (el, text, parts) {
      if (!parts) { el.textContent = text; return; }
      el.textContent = '';
      parts.forEach(function (p, i) {
        var s;
        if (i) { s = document.createElement('span'); s.className = 'svnty-giftbar__dot'; s.textContent = ' \u00b7 '; el.appendChild(s); }
        s = document.createElement('span'); s.className = 'svnty-giftbar__who';
        var m = /^(For|From) (.+)$/.exec(p);
        if (m && p !== 'For you') {
          var lab = document.createElement('span'); lab.className = 'svnty-giftbar__lab'; lab.textContent = m[1] + ' ';
          var nm = document.createElement('bdi'); nm.className = 'svnty-giftbar__name'; nm.setAttribute('dir', 'auto'); nm.textContent = m[2];
          s.appendChild(lab); s.appendChild(nm);
        } else { s.textContent = p; }
        el.appendChild(s);
      });
    };
    var swap = function (el, text, parts) {
      if (!el || el.textContent === text) return;
      if (reduce || !bar || bar.getAttribute('data-bar') !== 'on') { put(el, text, parts); return; }
      el.classList.add('is-swapping');
      window.setTimeout(function () { put(el, text, parts); el.classList.remove('is-swapping'); }, 120);
    };
    var back = inBar('[data-giftbar-back]'), card = $('[data-gift-card]');
    var LAND = window.matchMedia ? window.matchMedia('(max-width: 989px) and (max-height: 500px) and (orientation: landscape)') : null;
    /* P25 (the gift refuter's P2-4): the target is measured against the FULL slab (header + announcement bar: both return on the way
       up), never the parked one, so the card lands 16 px under the bar, not under the header. */
    if (back && card) back.addEventListener('click', function () {
      var hs = window.__svntyHeadstack, cs = window.getComputedStyle(document.documentElement);
      var ann = parseFloat(cs.getPropertyValue('--svnty-ann-h')) || 0;
      var slab = hs && typeof hs.h === 'function' ? hs.h() : (parseFloat(cs.getPropertyValue('--svnty-headstack-h')) || 64);
      /* P26 (R2 P3-N2): a rotated phone never brings the announcement bar back mid-page (svnty-headstack.js, THE LANDSCAPE LAW) */
      if (hs && typeof hs.hidden === 'function' && hs.hidden() && !(LAND && LAND.matches)) slab += ann;
      var y = card.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0) - slab - 16;
      window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    });

    /* the ladder the store can sell: {egp: variant_id} */
    var variants = null;
    var vjson = $('[data-gift-variants]');
    if (vjson) { try { variants = JSON.parse(vjson.textContent); delete variants._; } catch (e) { variants = null; } }
    var prices = variants ? Object.keys(variants).map(Number).filter(function (n) { return n > 0; }).sort(function (a, b) { return a - b; }) : [];
    var sellable = function (n) { return !!(variants && variants[String(n)]); };

    var parseLE = function (t) { var m = String(t || '').replace(/[^0-9]/g, ''); return m ? parseInt(m, 10) : null; };
    var measure = $('[data-gift-measure]');
    var fit = function () {
      if (!input) return;
      if (!measure) { input.style.inlineSize = ((input.value || input.placeholder || '').length + 1) + 'ch'; return; }
      measure.textContent = input.value || input.placeholder || '0';
      input.style.inlineSize = Math.ceil(measure.getBoundingClientRect().width + 3) + 'px';
    };
    if (field) field.addEventListener('click', function (e) { if (e.target !== input) input.focus(); });
    /* P28 lane E (gift refute P3-3, P3-4): with YOUR AMOUNT open and still empty the face (and the bar) keep the last amount they
       showed, never "EGP" alone; the face's name (role img) follows the amount, so a screen reader hears what the eye sees */
    var face = card ? card.querySelector('.svnty-gcard[role="img"]') : null;
    var faceKind = face ? ((face.querySelector('.svnty-gcard__kind') || {}).textContent || '').trim() : '';
    var paintCard = function () {
      var t = amount !== null ? money(amount) : (out ? out.textContent : '');
      if (!t || t === 'EGP') t = money(MIN);
      if (out) out.textContent = t;
      swap(barAmount, t);
      if (face) face.setAttribute('aria-label', (faceKind || 'Gift card') + ', ' + t);
    };
    var setHelp = function (text, bad) { if (help) { help.textContent = text; help.classList.toggle('is-invalid', !!bad); } if (field) field.classList.toggle('is-invalid', !!bad); };
    var openRise = function (r, on, focusEl) {
      if (!r) return;
      r.classList.toggle('is-open', on);
      r.setAttribute('aria-hidden', on ? 'false' : 'true');
      if ('inert' in r) r.inert = !on;
      if (on && focusEl) focusEl.focus({ preventScroll: false });
    };

    /* a radio group of buttons: one tab stop, the arrows move the choice */
    var radios = function (list, onChoose) {
      list.forEach(function (c, i) {
        c.addEventListener('click', function () { onChoose(c, false); });
        c.addEventListener('keydown', function (e) {
          var n = list.length, j = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % n;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + n) % n;
          else if (e.key === 'Home') j = 0;
          else if (e.key === 'End') j = n - 1;
          if (j === null) return;
          e.preventDefault(); onChoose(list[j], true);
        });
      });
    };
    var mark = function (list, c, cls) {
      list.forEach(function (o) { var on = o === c; o.classList.toggle(cls, on); o.setAttribute('aria-checked', on ? 'true' : 'false'); o.tabIndex = on ? 0 : -1; });
    };

    /* THE AMOUNTS */
    var choose = function (c, focus) {
      mark(chips, c, 'is-active');
      customOn = c === customChip;
      if (customOn) {
        amount = input ? parseLE(input.value) : null;
        if (amount !== null && !sellable(amount)) amount = null;
        openRise(rise, true, focus === 'input' ? input : null);
        if (amount === null) setHelp(helpDefault, false);
      } else {
        amount = parseLE(c.dataset.giftChip);
        openRise(rise, false, null);
        if (focus) c.focus({ preventScroll: true });
      }
      paintCard(); paintBuy();
    };
    radios(chips, function (c, kb) { choose(c, c === customChip ? 'input' : kb); });

    /* YOUR AMOUNT: digits while typing, the card follows; clamped and snapped to the step when the field is left */
    var settle = function () {
      if (!input) return;
      var n = parseLE(input.value);
      if (n === null) { amount = null; if (customNote) customNote.textContent = rangeNote; setHelp('Enter an amount to go on the card.', true); paintCard(); paintBuy(); return; }
      var was = n;
      n = Math.min(MAX, Math.max(MIN, Math.round(n / STEP) * STEP));
      amount = n;
      input.value = fmt(n); fit();
      if (customNote) customNote.textContent = money(n);
      if (was < MIN) setHelp('The smallest gift card is ' + money(MIN) + '. Set to that.', false);
      else if (was > MAX) setHelp('The largest gift card is ' + money(MAX) + '. Set to that.', false);
      else if (n !== was) setHelp('Rounded to ' + money(n) + '. Amounts go in steps of ' + money(STEP) + '.', false);
      else setHelp(helpDefault, false);
      paintCard(); paintBuy();
    };
    if (input) {
      input.addEventListener('input', function () {
        var digits = input.value.replace(/[^0-9]/g, '').slice(0, 6);
        if (digits !== input.value) input.value = digits;
        fit();
        amount = digits ? parseInt(digits, 10) : null;
        if (customNote) customNote.textContent = amount !== null ? money(amount) : rangeNote;
        setHelp(helpDefault, false);
        paintCard(); paintBuy();
      });
      input.addEventListener('blur', settle);
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); input.blur(); } });
      input.addEventListener('focus', function () { if (input.value) input.value = input.value.replace(/[^0-9]/g, ''); fit(); paintBuy(); });
      fit();
    }

    /* WHO IS IT FOR */
    var modes = Array.prototype.slice.call(root.querySelectorAll('[data-gift-mode]'));
    var riseOther = $('[data-gift-rise-other]'), selfNote = $('[data-gift-self-note]');
    var mode = 'other';
    var toIn = $('[data-gift-to-input]'), fromIn = $('[data-gift-from-input]');
    var toOut = $('[data-gift-to]'), fromOut = $('[data-gift-from]');
    var emailIn = $('[data-gift-email]'), emailErr = $('[data-gift-email-err]');
    var msgIn = $('[data-gift-message]'), count = $('[data-gift-count]');
    /* P26-1: the bar's caps line names both people, "For Zezo · From Abdul", and degrades to whichever is typed */
    var paintFor = function () {
      if (mode === 'self') { swap(barFor, 'For you', ['For you']); return; }
      var to = toIn ? toIn.value.trim() : '', from = fromIn ? fromIn.value.trim() : '';
      var parts = [to ? 'For ' + to : '', from ? 'From ' + from : ''].filter(Boolean);
      swap(barFor, parts.join(' \u00b7 '), parts);
    };
    var paintNames = function () {
      var other = mode === 'other';
      if (toOut) toOut.textContent = other && toIn ? toIn.value.trim() : '';
      if (fromOut) fromOut.textContent = other && fromIn ? fromIn.value.trim() : '';
      paintFor();
    };
    var setMode = function (c, kb) {
      mark(modes, c, 'is-selected');
      mode = c.dataset.giftMode === 'self' ? 'self' : 'other';
      openRise(riseOther, mode === 'other', null);
      if (selfNote) selfNote.hidden = mode !== 'self';
      if (kb) c.focus({ preventScroll: true });
      clearErr(emailIn, emailErr); clearErr(null, dateErr);
      paintNames(); paintBuy();
    };
    radios(modes, setMode);
    if (toIn) toIn.addEventListener('input', paintNames);
    if (fromIn) fromIn.addEventListener('input', paintNames);
    var showErr = function (inp, err, text) { if (inp) { inp.classList.add('is-invalid'); inp.setAttribute('aria-invalid', 'true'); } if (err) { err.textContent = text; err.hidden = false; } };
    var clearErr = function (inp, err) { if (inp) { inp.classList.remove('is-invalid'); inp.removeAttribute('aria-invalid'); } if (err) { err.textContent = ''; err.hidden = true; } };
    var emailOk = function () { return !!(emailIn && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(emailIn.value.trim())); };
    if (emailIn) {
      emailIn.addEventListener('input', function () { clearErr(emailIn, emailErr); });
      emailIn.addEventListener('blur', function () { if (emailIn.value.trim() && !emailOk()) showErr(emailIn, emailErr, 'Check their email: it should look like name@example.com.'); });
    }
    var paintCount = function () { if (!msgIn || !count) return; var n = msgIn.value.length; count.textContent = n + ' / ' + (msgIn.maxLength > 0 ? msgIn.maxLength : 200); count.hidden = n < 150; };
    if (msgIn) msgIn.addEventListener('input', paintCount);

    /* SEND ON: Now (the moment the payment clears), Tomorrow, or a day she picks, up to 90 days ahead */
    var sends = Array.prototype.slice.call(root.querySelectorAll('[data-gift-send]'));
    var riseDate = $('[data-gift-rise-date]'), sendOn = $('[data-gift-sendon]'), dateErr = $('[data-gift-date-err]');
    var calTrigger = riseDate ? riseDate.querySelector('[data-cal-trigger]') : null;
    var sendNote = $('[data-gift-send-note]');
    var sendNotes = { now: sendNote ? sendNote.textContent : '', tomorrow: 'Sent tomorrow morning, in their inbox.', pick: 'Sent the morning of the day you choose.' };
    var send = 'now';
    var setSend = function (c, kb) {
      mark(sends, c, 'is-selected');
      send = c.dataset.giftSend;
      openRise(riseDate, send === 'pick', null);
      if (sendNote) sendNote.textContent = sendNotes[send] || '';
      if (kb) c.focus({ preventScroll: true });
      clearErr(calTrigger, dateErr);
    };
    radios(sends, setSend);
    root.addEventListener('svnty:calendar:change', function () { clearErr(calTrigger, dateErr); keep(); });
    var sendDay = function () {
      if (send === 'tomorrow') return isoDay(dayAt(1));
      if (send === 'pick') {
        var d = parseDay(sendOn ? sendOn.value : '');
        if (!d) return { err: 'Choose the day it is sent.' };
        if (d < dayAt(0)) return { err: 'Choose today or a day after it.' };
        if (d > dayAt(SEND_MAX)) return { err: 'Choose a day within the next ' + SEND_MAX + ' days.' };
        return d.getTime() === dayAt(0).getTime() ? '' : isoDay(d);
      }
      return '';
    };

    /* THE BUY */
    var add = $('[data-gift-add]'), addLabel = $('[data-gift-add-label]'), status = $('[data-gift-status]');
    var busy = false;
    var canBuy = function () { return amount !== null && sellable(amount); };
    /* P28 lane E (gift refute P3-2): while the field has her focus the button stays in ink (a tap leaves the field, which settles the
       amount onto the step before the add); it greys only for an amount the store cannot sell once she has left the field */
    var paintBuy = function () { if (add) add.setAttribute('aria-disabled', !busy && (canBuy() || (customOn && (amount === null || document.activeElement === input))) ? 'false' : 'true'); };
    var say = function (t, bad, link) {
      if (!status) return;
      status.textContent = t || ''; status.classList.toggle('is-error', !!bad);
      if (link) { status.appendChild(document.createTextNode(' ')); var a = document.createElement('a'); a.href = link.href; a.textContent = link.text; status.appendChild(a); status.appendChild(document.createTextNode('.')); }
    };
    var addTimer = 0;
    var setState = function (state) {
      if (!add) return;
      add.classList.toggle('is-loading', state === 'adding');
      add.classList.toggle('is-added', state === 'added');
      add.setAttribute('aria-busy', state === 'adding' ? 'true' : 'false');
      if (addLabel) addLabel.textContent = state === 'added' ? 'In your bag' : (add.dataset.label || 'Add to bag');
    };
    window.addEventListener('pageshow', function () { busy = false; window.clearTimeout(addTimer); setState('idle'); paintBuy(); });
    /* P28 lane E (P3-1): the form is the no-script road only; with the script the button's click below is the one add */
    var buyForm = $('[data-gift-buy]');
    if (buyForm) buyForm.addEventListener('submit', function (e) { e.preventDefault(); });
    /* P28 lane E (launch audit cart P2-4): an add is not idempotent: only a 429 or a 503 (the store did not take it) is asked again,
       once (Retry-After, capped 4 s); a non-ok answer is read for Shopify's own JSON words (a 422: not enough left), else said plainly */
    var postAdd = function (opts, tries) {
      return fetch(cartAddUrl(), opts).then(function (r) {
        if ((r.status === 429 || r.status === 503) && !tries) {
          var after = parseFloat(r.headers.get('Retry-After'));
          return new Promise(function (ok) { window.setTimeout(ok, Math.min(after > 0 ? after * 1000 : 1200, 4000)); }).then(function () { return postAdd(opts, 1); });
        }
        if (r.status === 429 || r.status >= 500) return { status: r.status, description: 'The store is busy for a moment. Try again in a few seconds.' };
        return r.json().catch(function () { return { status: r.status || 1, description: 'Could not add it to your bag. Try again in a moment.' }; });
      });
    };
    if (add) {
      add.addEventListener('click', function () {
        if (busy) return;
        say('');
        if (customOn && input && document.activeElement === input) settle();   /* a tap while the field still has focus settles it first */
        if (customOn && amount === null) { if (input) input.focus(); setHelp('Enter an amount to go on the card.', true); return; }
        if (!canBuy()) { say('That amount cannot be bought right now. Choose one of the amounts above.', true); return; }
        var day = '';
        if (mode === 'other') {
          if (!emailOk()) { showErr(emailIn, emailErr, emailIn && emailIn.value.trim() ? 'Check their email: it should look like name@example.com.' : 'Add their email so the card reaches them.'); if (emailIn) emailIn.focus(); return; }
          day = sendDay();
          if (day && day.err) { showErr(calTrigger, dateErr, day.err); if (calTrigger) calTrigger.focus(); return; }
        }
        busy = true; window.clearTimeout(addTimer); setState('adding'); paintBuy();
        var body = new FormData();
        body.append('id', String(variants[String(amount)])); body.append('quantity', '1');
        if (mode === 'other') {
          body.append('properties[__shopify_send_gift_card_to_recipient]', 'on');
          body.append('properties[Recipient email]', emailIn.value.trim());
          if (toIn && toIn.value.trim()) body.append('properties[Recipient name]', toIn.value.trim());
          if (msgIn && msgIn.value.trim()) body.append('properties[Message]', msgIn.value.trim());
          if (day) body.append('properties[Send on]', day);
          body.append('properties[__shopify_offset]', String(new Date().getTimezoneOffset()));
          if (fromIn && fromIn.value.trim()) body.append('properties[From]', fromIn.value.trim());
        }
        var ids = sectionIds(); if (ids.length) body.append('sections', ids.join(','));
        /* THE WALL (assets/svnty-wall.js): a fetch never waits forever */
        var addOpts = { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: body };
        var addDone = window.svntyWall ? window.svntyWall(addOpts, 12000) : function () {};
        var added = amount;
        postAdd(addOpts, 0)
          .then(function (r) { addDone(); return r; }, function (e) { addDone(); throw e; })
          .then(function (res) {
            if (res && res.status) { say(res.description || res.message || 'Could not add it to your bag.', true); return; }
            var cartOpts = {};
            var cartDone = window.svntyWall ? window.svntyWall(cartOpts, 8000) : function () {};
            return fetch('/cart.js', cartOpts).then(function (r) { cartDone(); if (!r.ok) throw new Error('cart ' + r.status); return r.json(); }, function (e) { cartDone(); throw e; }).catch(function () { return null; }).then(function (cart) {
              document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: {
                resource: cart, sourceId: 'svnty-gift',
                data: { source: 'svnty-gift', sections: res.sections, didError: false, itemCount: cart && typeof cart.item_count === 'number' ? cart.item_count : 1, productId: res.product_id, variantId: variants[String(added)] }
              } }));
              setState('added');
              root.dispatchEvent(new CustomEvent('svnty:gift:added'));
              say(money(added) + ' gift card is in your bag.', false, { href: '/cart', text: 'View your bag' });
              addTimer = window.setTimeout(function () { setState('idle'); }, 1800);
            });
          })
          .catch(function () { say('Could not reach the store. Try again in a moment.', true); })
          .then(function () { busy = false; if (add.classList.contains('is-loading')) setState('idle'); paintBuy(); });
      });
      if (addLabel) add.dataset.label = addLabel.textContent;
    }

    /* the opening state: the preselected tile, the custom field closed, for someone else, now */
    var pre = chips.filter(function (c) { return c.classList.contains('is-active'); })[0];
    if (pre) { amount = pre === customChip ? null : parseLE(pre.dataset.giftChip); customOn = pre === customChip; }
    openRise(rise, customOn, null);
    if (modes.length) setMode(modes.filter(function (m) { return m.classList.contains('is-selected'); })[0] || modes[0], false);
    if (sends.length) setSend(sends[0], false);
    paintCard(); paintBuy();

    /* NEVER LOSE WHAT SHE TYPED: the whole form in this tab for two hours (a reload, Back, Forward), quietly (no focus, no
       scroll); a fresh visit opens clean; a gift card that reached the bag forgets it. */
    var KEY = 'svnty:gift:v2', LIFE = 7200000;
    var snap = function () {
      var c = chips.filter(function (x) { return x.classList.contains('is-active'); })[0];
      return { t: Date.now(), chip: c ? chips.indexOf(c) : -1, custom: input ? input.value : '', mode: mode, to: toIn ? toIn.value : '', from: fromIn ? fromIn.value : '', email: emailIn ? emailIn.value : '', msg: msgIn ? msgIn.value : '', send: send, day: sendOn ? sendOn.value : '' };
    };
    var keep = function () { try { sessionStorage.setItem(KEY, JSON.stringify(snap())); } catch (e) {} };
    var forget = function () { try { sessionStorage.removeItem(KEY); } catch (e) {} };
    var kept = function () { try { var v = JSON.parse(sessionStorage.getItem(KEY) || 'null'); return v && Date.now() - (v.t || 0) < LIFE ? v : null; } catch (e) { return null; } };
    var navType = '';
    try { navType = ((performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {}).type || ''; } catch (e) {}
    var was = (navType === 'reload' || navType === 'back_forward') ? kept() : null;
    if (!was) forget();
    else {
      if (input && was.custom) input.value = was.custom;
      if (was.chip >= 0 && chips[was.chip]) choose(chips[was.chip], false);
      if (customOn && input && input.value) { amount = parseLE(input.value); fit(); if (customNote && amount !== null) customNote.textContent = money(amount); paintCard(); }
      [[toIn, was.to], [fromIn, was.from], [emailIn, was.email], [msgIn, was.msg]].forEach(function (p) { if (p[0] && typeof p[1] === 'string') p[0].value = p[1]; });
      var m = modes.filter(function (x) { return x.dataset.giftMode === was.mode; })[0]; if (m) setMode(m, false);
      if (sendOn && was.day) sendOn.value = was.day;
      var s = sends.filter(function (x) { return x.dataset.giftSend === was.send; })[0]; if (s) setSend(s, false);
      paintCount(); paintNames(); paintBuy();
    }
    root.addEventListener('input', keep);
    root.addEventListener('change', keep);
    root.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-gift-chip], [data-gift-mode], [data-gift-send]')) keep(); });
    root.addEventListener('svnty:gift:added', forget);
  };
  var init = function () { document.querySelectorAll('.svnty-gift').forEach(setup); };
  init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["svnty-help-centre"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-svnty-help]');
  if (!root) return;
  var input = root.querySelector('[data-svnty-help-input]');
  var clear = root.querySelector('[data-svnty-help-clear]');
  var count = root.querySelector('[data-svnty-help-count]');
  var empty = root.querySelector('[data-svnty-help-empty]');
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-svnty-help-card]'));
  var groups = Array.prototype.slice.call(root.querySelectorAll('[data-svnty-help-group]'));
  var chips = Array.prototype.slice.call(root.querySelectorAll('[data-svnty-help-chip]'));
  var index = root.querySelector('[data-svnty-help-index]');
  var total = cards.length;
  var word = count ? count.textContent.replace(/^\s*\d+\s*/, '').trim() : 'answers';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* the words of every card, once */
  cards.forEach(function (c) {
    c.__svntyText = (c.textContent || '').toLowerCase().replace(/\s+/g, ' ');
  });

  function norm(s) { return (s || '').toLowerCase().replace(/[ً-ْ]/g, '').replace(/\s+/g, ' ').trim(); }

  function filter(q) {
    q = norm(q);
    var terms = q ? q.split(' ').filter(Boolean) : [];
    var shown = 0;
    cards.forEach(function (c) {
      var hit = !terms.length || terms.every(function (t) { return c.__svntyText.indexOf(t) >= 0; });
      c.hidden = !hit;
      if (hit) shown += 1;
      if (terms.length && hit && shown <= 3) c.open = true;
      else if (!terms.length && c.__svntyOpenedByFilter) { c.open = false; }
      if (terms.length && hit) c.__svntyOpenedByFilter = true;
    });
    groups.forEach(function (g) {
      var any = g.querySelector('[data-svnty-help-card]:not([hidden])');
      g.hidden = !any;
    });
    if (index) index.hidden = !!terms.length;
    if (empty) empty.hidden = shown > 0;
    if (count) count.textContent = (terms.length ? shown : total) + ' ' + word;
    if (clear) clear.hidden = !q;
  }

  if (input) {
    var t = null;
    input.addEventListener('input', function () {
      window.clearTimeout(t);
      t = window.setTimeout(function () { filter(input.value); }, 80);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && input.value) { input.value = ''; filter(''); }
    });
  }
  if (clear && input) {
    clear.addEventListener('click', function () { input.value = ''; filter(''); input.focus(); });
  }

  /* the hash opens a question or lands on a category */
  function openHash() {
    var h = location.hash && location.hash.slice(1);
    if (!h) return;
    var el = document.getElementById(h);
    if (!el) return;
    if (el.tagName === 'DETAILS') { el.open = true; }
    el.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
  }
  window.addEventListener('hashchange', openHash);
  if (location.hash) window.setTimeout(openHash, 60);

  /* THE INDEX FOLLOWS THE SCROLL (D8-29, 16:04: "as I scroll the current section gets highlighted and the ribbon auto
     swipes in a clean, smooth, subtle motion, following the current position 100 % accurately; secure it fully, always,
     under any iPhone session"). Not an observer: on every scroll frame the active group is the last one whose top has
     passed the line under the sticky rail, exactly what the eye reads; the rail glides so the active chip sits centred
     (its own scroller, never the page); a chip tap holds the choice while the page glides to it. Resize, rotation, the
     back-forward cache, late fonts and the search (hidden groups are skipped) all re-run it. */
  var list = index && index.querySelector('.svnty-help__index-list');
  var chipById = {};
  chips.forEach(function (ch) { chipById[ch.getAttribute('data-svnty-help-chip')] = ch; });
  var activeId = null, hold = 0, raf = 0;

  function center(chip) {
    if (!list || !chip) return;
    if (list.scrollWidth <= list.clientWidth + 1) return;          /* the desktop list: nothing to glide */
    var l = list.getBoundingClientRect(), c = chip.getBoundingClientRect();
    var target = list.scrollLeft + (c.left - l.left) - (l.width - c.width) / 2;
    target = Math.max(0, Math.min(target, list.scrollWidth - list.clientWidth));
    if (Math.abs(target - list.scrollLeft) < 1) return;
    try { list.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { list.scrollLeft = target; }
  }
  function setActive(id) {
    if (!id || id === activeId) return;
    activeId = id;
    chips.forEach(function (ch) { ch.classList.toggle('is-active', ch.getAttribute('data-svnty-help-chip') === id); });
    center(chipById[id]);
  }
  function current() {
    var live = groups.filter(function (g) { return !g.hidden; });
    if (!live.length) return null;
    var line = (index ? index.getBoundingClientRect().bottom : 0) + 12;
    var doc = document.documentElement;
    if (window.innerHeight + (window.pageYOffset || 0) >= doc.scrollHeight - 2) return live[live.length - 1].id;
    var best = live[0];
    for (var i = 0; i < live.length; i += 1) {
      if (live[i].getBoundingClientRect().top <= line) best = live[i]; else break;
    }
    return best.id;
  }
  function tick() {
    raf = 0;
    if (Date.now() < hold) return;
    setActive(current());
  }
  function schedule() { if (!raf) raf = window.requestAnimationFrame(tick); }

  chips.forEach(function (ch) {
    ch.addEventListener('click', function (e) {
      var id = ch.getAttribute('data-svnty-help-chip');
      var g = document.getElementById(id);
      if (!g) return;
      e.preventDefault();
      try { history.replaceState(null, '', '#' + id); } catch (err) {}
      hold = Date.now() + (reduce ? 50 : 700);
      setActive(id);
      g.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
    });
  });
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('orientationchange', schedule);
  window.addEventListener('pageshow', function () { hold = 0; activeId = null; schedule(); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  if (input) input.addEventListener('input', function () { window.setTimeout(schedule, 120); });
  window.setTimeout(schedule, 0);
  window.setTimeout(schedule, 400);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["svnty-size-guide-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var root = document.querySelector('[data-svnty-sizeguide]');
  if (!root) return;
  var q = function (sel) { return root.querySelector(sel); };
  var input = q('[data-sg-input]'), clearBtn = q('[data-sg-clear]'), types = q('[data-sg-types]'), results = q('[data-sg-results]');
  var state = q('[data-sg-state]'), cardRail = q('[data-sg-card]');
  var stage = q('[data-sg-stage]'), mount = q('[data-sg-mount]'), loading = q('[data-sg-loading]'), errorEl = q('[data-sg-error]');
  var cardCache = {};
  var idleLine = state.textContent;
  var catalog = null, activeType = '', current = null, sheetCache = {}, seq = 0, cursor = -1;
  var base = root.getAttribute('data-fetch-base') || '/';
  if (base.charAt(base.length - 1) !== '/') base += '/';

  /* ------------------------------------------------------------ the catalog: the store's own JSON, read once */
  /* P22-21 ARABIC IS READ: the families and the words people type, folded to the catalog's own English before the Latin fold */
  var AR = [['تي شيرت', 'typetshirt'], ['تيشيرت', 'typetshirt'], ['تيشرت', 'typetshirt'], ['سويت شيرت', 'sweatshirt'], ['سويتشيرت', 'sweatshirt'], ['جينز', 'jeans'],
    ['قميص', 'shirt'], ['قمصان', 'shirt'], ['بولو', 'polo'], ['هوديز', 'hoodie'], ['هودي', 'hoodie'], ['جاكيتات', 'jacket'], ['جاكيت', 'jacket'], ['جاكت', 'jacket'],
    ['بنطلونات', 'pants'], ['بنطلون', 'pants'], ['تريكو', 'knitwear'], ['بلوفر', 'knitwear'], ['كنزه', 'knitwear'], ['فيست', 'vest'], ['صديري', 'vest'], ['جيليه', 'vest'], ['اكسفورد', 'oxford']];
  function arab(s) {
    s = String(s || '');
    if (!/[\u0600-\u06FF]/.test(s)) return s;
    s = s.replace(/[\u064B-\u0652\u0640]/g, '').replace(/[\u0623\u0625\u0622]/g, '\u0627').replace(/\u0629/g, '\u0647').replace(/\u0649/g, '\u064A');
    AR.forEach(function (p) { s = s.split(p[0]).join(' ' + p[1] + ' '); });
    return s;
  }
  function norm(s) { return arab(s).toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
  function loadCatalog() {
    if (catalog) return Promise.resolve(catalog);
    var isl = document.querySelector('[data-sg-catalog]'), rows = [];
    try { rows = JSON.parse(isl ? isl.textContent : '[]'); } catch (e) { rows = []; }
    catalog = rows.map(function (r) {
      return { handle: r.h, title: r.t, type: r.y || '', sizes: r.s || '', img: r.i || '', ar: Number(r.a) || 0, key: norm(r.t + ' ' + r.y + ' ' + (r.g || '')) + ' type' + norm(r.y).replace(/ /g, '') };
    }).filter(function (p) { return p.handle; });
    if (!catalog.length) { state.textContent = 'The pieces did not load. Refresh the page and try again.'; catalog = null; return Promise.resolve(null); }
    buildTypes();
    return Promise.resolve(catalog);
  }

  /* ------------------------------------------------------------ the families */
  function buildTypes() {
    var seen = {}, list = [];
    catalog.forEach(function (p) { if (p.type && !seen[p.type]) { seen[p.type] = 1; list.push(p.type); } });
    list.sort();
    if (types.children.length) return;   /* printed with the page (P17-18); built here only if the page printed none */
    var html = '<button type="button" class="svnty-sg__type is-on" data-type="" aria-pressed="true">All</button>';
    list.forEach(function (t) { html += '<button type="button" class="svnty-sg__type" data-type="' + esc(t) + '" aria-pressed="false">' + esc(t) + '</button>'; });
    types.innerHTML = html;
  }
  types.addEventListener('click', function (e) {
    var b = e.target.closest('.svnty-sg__type'); if (!b) return;
    activeType = b.getAttribute('data-type') || '';
    Array.prototype.forEach.call(types.children, function (c) { var on = c === b; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    render(input.value);   /* P20-15: a family chip is a filter, not a search: the field is not focused (the phone's keyboard rose on every tap) */
  });

  /* ------------------------------------------------------------ the search */
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function mark(title, words) {
    var out = esc(title);
    words.forEach(function (w) { if (!w) return; out = out.replace(new RegExp('(' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig'), '<mark>$1</mark>'); });
    return out;
  }
  function search(text) {
    var words = norm(text).split(' ').filter(Boolean);
    var list = catalog.filter(function (p) { return !activeType || p.type === activeType; });
    if (!words.length) return activeType ? list : [];
    return list.map(function (p) {
      var score = 0, t = norm(p.title);
      words.forEach(function (w) {
        if (t.indexOf(w) === 0) score += 6;
        else if (t.indexOf(' ' + w) > -1) score += 4;
        else if (t.indexOf(w) > -1) score += 2;
        else if (p.key.indexOf(w) > -1) score += 1;
        else score -= 3;
      });
      return { p: p, s: score };
    }).filter(function (x) { return x.s > 0; }).sort(function (a, b) { return b.s - a.s || a.p.title.localeCompare(b.p.title); }).map(function (x) { return x.p; });
  }
  /* P22-21 WHAT SHE TYPED (svnty-never-lose-what-she-typed): the field and the family, this tab, 2 hours; back on a reload, a Back or a Forward */
  var FIND = 'svnty:sg-find', PLACE = 'svnty:sg-place', LIFE = 7200000;
  function keep(k, v) { try { if (v) sessionStorage.setItem(k, JSON.stringify(v)); else sessionStorage.removeItem(k); } catch (e) {} }
  function kept(k) { try { var v = JSON.parse(sessionStorage.getItem(k) || 'null'); return v && Date.now() - (v.t || 0) < LIFE ? v : null; } catch (e) { return null; } }
  function render(text) {
    keep(FIND, text || activeType ? { q: String(text || ''), ty: activeType, t: Date.now() } : null);
    if (!catalog) { loadCatalog().then(function () { if (catalog) render(input.value); }); return; }
    var words = norm(text).split(' ').filter(Boolean);
    var list = search(text).slice(0, 12);
    clearBtn.hidden = !text;
    cursor = -1;
    if (!list.length) {
      results.innerHTML = ''; results.hidden = true; input.setAttribute('aria-expanded', 'false');
      if (words.length || String(text || '').trim()) state.textContent = 'Nothing called “' + text.trim() + '” here. Try the family chips.';
      else state.textContent = idleLine;
      state.hidden = false;
      return;
    }
    results.innerHTML = list.map(function (p, i) {
      return '<li role="presentation"><button type="button" class="svnty-sg__result" role="option" aria-selected="false" data-handle="' + esc(p.handle) + '" id="SvntySgOpt' + i + '">' +
        '<span class="svnty-sg__result-pic">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" width="56"' + (p.ar ? ' height="' + Math.round(56 / p.ar) + '"' : '') + ' loading="lazy">' : '') + '</span>' +
        '<span class="svnty-sg__result-text"><span class="svnty-sg__result-title">' + mark(p.title, words) + '</span><span class="svnty-sg__result-kind">' + esc(p.type) + (p.sizes ? ' &middot; ' + esc(p.sizes) : '') + '</span></span>' +
        '<span class="svnty-sg__result-arrow" aria-hidden="true"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6c0 0 6 4.4 6 6s-6 6-6 6"/></svg></span></button></li>';
    }).join('');
    results.hidden = false; input.setAttribute('aria-expanded', 'true'); state.hidden = false;
    state.textContent = list.length === 1 ? 'One piece.' : list.length + ' pieces' + (activeType && !words.length ? ' in ' + activeType + '.' : '.');
  }
  var timer = null;
  input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(function () { render(input.value); }, 80); });
  input.addEventListener('focus', function () { loadCatalog(); });
  input.addEventListener('keydown', function (e) {
    var opts = results.hidden ? [] : results.querySelectorAll('.svnty-sg__result');
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      if (!opts.length) return; e.preventDefault();
      cursor = e.key === 'ArrowDown' ? Math.min(opts.length - 1, cursor + 1) : Math.max(0, cursor - 1);
      Array.prototype.forEach.call(opts, function (o, i) { o.setAttribute('aria-selected', i === cursor ? 'true' : 'false'); });
      input.setAttribute('aria-activedescendant', opts[cursor].id); opts[cursor].scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'Enter') {
      if (!opts.length) return; e.preventDefault(); pick((opts[cursor > -1 ? cursor : 0]).getAttribute('data-handle'));
    } else if (e.key === 'Escape') { input.value = ''; render(''); }
  });
  clearBtn.addEventListener('click', function () { input.value = ''; render(''); input.focus({ preventScroll: true }); });
  results.addEventListener('click', function (e) { var b = e.target.closest('.svnty-sg__result'); if (b) pick(b.getAttribute('data-handle')); });
  var chips = q('[data-sg-chips]');
  if (chips) chips.addEventListener('click', function (e) { var b = e.target.closest('.svnty-sg__chip'); if (b) pick(b.getAttribute('data-handle')); });

  /* ------------------------------------------------------------ the stage: the piece's own sheet, inline */
  /* quiet: THE DESK'S FIRST VIEW (P17-18) stages a piece she did not pick, so the address bar and the scroll stay hers */
  function pick(handle, quiet) {
    if (!handle) return;
    loadCatalog().then(function () {
      if (!catalog) return;
      var p = catalog.filter(function (x) { return x.handle === handle; })[0];
      if (!p) { if (!quiet) state.textContent = 'That piece is no longer in the store.'; return; }
      current = p;
      results.hidden = true; input.setAttribute('aria-expanded', 'false');
      if (!quiet) state.hidden = true;   /* P20-15: the list's count does not stand over a picked piece */
      stage.hidden = false; root.classList.add('is-staged');
      if (chips) Array.prototype.forEach.call(chips.querySelectorAll('.svnty-sg__chip'), function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-handle') === p.handle ? 'true' : 'false'); });
      loadCard(p.handle);
      if (!quiet) { try { var u = new URL(location.href); u.searchParams.set('product', p.handle); history.replaceState(history.state, '', u.pathname + u.search); } catch (e) {} }
      loadSheet(p.handle);
      /* P22-21 THE LANDING: 16 px under the header as it will stand (the way down parks the bar); a refresh keeps her own place */
      if (!quiet && place == null) setTimeout(function () { land(stage); }, 40);
    });
  }
  /* P22-21 THE SLAB AT THE LANDING: the tracking page's slabAt (P19), the same reading of the header's stack */
  function slabAt(top) {
    var de = document.documentElement, cs = getComputedStyle(de);
    var now = parseFloat(cs.getPropertyValue('--svnty-headstack-h')) || 64, bar = parseFloat(cs.getPropertyValue('--svnty-ann-h')) || 0;
    var head = de.classList.contains('svnty-bar-hidden') ? now : Math.max(0, now - bar);
    if (!head) return now;
    return top - head - 16 > window.scrollY + 6 ? head : head + bar;
  }
  function land(el) {
    try {
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var top = window.scrollY + el.getBoundingClientRect().top;
      window.scrollTo({ top: Math.max(0, top - slabAt(top) - 16), behavior: calm ? 'auto' : 'smooth' });
    } catch (e) {}
  }
  /* P22-21 HER PLACE AFTER A REFRESH: held until the card and the chart stand, then given back (4 s at most) */
  var place = null;
  function settle(force) {
    if (place == null) return;
    if (!force && !(cardRail.firstElementChild && mount.firstElementChild)) return;
    var y = place; place = null;
    requestAnimationFrame(function () { window.scrollTo(0, y); });
  }
  /* THE CARD v2, the store's own (sections/svnty-card-fetch.liquid); its ids renamed for this host as the wishlist does */
  function loadCard(handle) {
    cardRail.innerHTML = '';
    var go = function (li) { if (!li || current.handle !== handle) return; cardRail.innerHTML = ''; cardRail.appendChild(document.importNode(li, true)); settle(); };
    if (cardCache[handle]) return go(cardCache[handle]);
    fetch(base + 'products/' + handle + '?section_id=svnty-card-fetch', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (txt) {
        var li = txt && new DOMParser().parseFromString(txt, 'text/html').querySelector('li[data-svnty-card-fetch]');
        if (!li) return null;
        var pid = li.getAttribute('data-svnty-fetch-pid') || '';
        Array.prototype.forEach.call(li.querySelectorAll('link[rel="stylesheet"]'), function (l) { if (document.querySelector('link[href="' + l.getAttribute('href') + '"]')) l.remove(); });
        if (pid) { var wrap = document.createElement('div'); wrap.innerHTML = li.outerHTML.split('recent-' + pid).join('sgp-' + pid).split('recent' + pid).join('sgp' + pid); li = wrap.firstElementChild; }
        /* P17-29 (round 3): the picture asks for the stage's own box (half the piece row less 8 px on the phone, 240 px from 750),
           set while the card is still inert, so nothing is fetched twice; the fetched card carries the collection grid's string */
        Array.prototype.forEach.call(li.querySelectorAll('img[sizes]'), function (im) { im.setAttribute('sizes', '(min-width: 750px) 240px, calc((100vw - 48px) / 2)'); });
        cardCache[handle] = li; return li;
      })
      .catch(function () { return null; })
      .then(go);
  }
  function showLoading(on) { loading.hidden = !on; loading.setAttribute('aria-hidden', on ? 'false' : 'true'); }
  function fetchSheet(handle) {
    if (sheetCache[handle]) return Promise.resolve(sheetCache[handle]);
    return fetch(base + 'products/' + handle + '?section_id=svnty-size-sheet-fetch', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('sheet'); return r.text(); })
      .then(function (t) {
        var doc = new DOMParser().parseFromString(t, 'text/html');
        var el = doc.querySelector('[data-svnty-ssheet]'); if (!el) throw new Error('no sheet');
        /* the sheet's own words and engine: run once; the chart's JSON stays data */
        Array.prototype.forEach.call(doc.querySelectorAll('script'), function (old) {
          if (el.contains(old)) return;
          var ty = (old.getAttribute('type') || '').toLowerCase(); if (ty && ty !== 'text/javascript' && ty !== 'module') return;
          var src = old.getAttribute('src');
          if (src && Array.prototype.some.call(document.scripts, function (x) { return x.getAttribute('src') === src; })) return;
          var n = document.createElement('script'); if (src) n.src = src; else n.textContent = old.textContent; document.head.appendChild(n);
        });
        el.setAttribute('data-svnty-ssheet-door', 'guide:' + handle);
        /* the figure's nine states are switched by id (#s-narrow-average...): those ids stay; every other id becomes this host's own */
        Array.prototype.forEach.call(el.querySelectorAll('[id]'), function (x) { if (/^s-/.test(x.id)) return; x.id = x.id + '-guide-' + handle; });
        Array.prototype.forEach.call(el.querySelectorAll('[aria-labelledby]'), function (x) { x.setAttribute('aria-labelledby', x.getAttribute('aria-labelledby').split(' ').map(function (k) { return k + '-guide-' + handle; }).join(' ')); });
        var panel = el.querySelector('.svnty-ssheet__panel');
        if (panel) { panel.setAttribute('role', 'region'); panel.removeAttribute('aria-modal'); panel.removeAttribute('tabindex'); }
        el.removeAttribute('hidden'); el.classList.add('svnty-ssheet--inline');
        sheetCache[handle] = document.importNode(el, true);
        return sheetCache[handle];
      });
  }
  function whenMounter(cb, tries) {
    if (window.SVNTY && window.SVNTY.sizeSheet && typeof window.SVNTY.sizeSheet.mount === 'function') return cb(true);
    if ((tries || 0) > 80) return cb(false);
    setTimeout(function () { whenMounter(cb, (tries || 0) + 1); }, 50);
  }
  function loadSheet(handle) {
    var my = ++seq;
    errorEl.hidden = true; mount.innerHTML = ''; showLoading(true);
    fetchSheet(handle).then(function (el) {
      if (my !== seq) return;
      whenMounter(function (ok) {
        if (my !== seq) return;
        showLoading(false);
        mount.appendChild(el);
        if (ok && !el.__svntyMounted) { try { window.SVNTY.sizeSheet.mount(el, function () { return stage; }); el.__svntyMounted = true; } catch (e) {} }
        settle();
      });
    }).catch(function () { if (my !== seq) return; showLoading(false); errorEl.hidden = false; });
  }
  q('[data-sg-retry]').addEventListener('click', function () { if (current) { delete sheetCache[current.handle]; loadSheet(current.handle); } });
  q('[data-sg-change]').addEventListener('click', function () {
    try { var u = new URL(location.href); u.searchParams.delete('product'); history.replaceState(history.state, '', u.pathname + (u.search || '')); } catch (e) {}
    /* P20-15 CHANGE PIECE (the owner: it ran to the search field, raised the keyboard and left the old piece standing). On one
       column the stage folds shut, the finder is clean again and stands under the header; no keyboard. Beside the finder (two
       columns) the piece stays until another is picked, and the field is focused for a mouse only. */
    var finder = root.querySelector('[data-sg-finder]'), mm = window.matchMedia ? function (s) { return window.matchMedia(s).matches; } : function () { return false; };
    var calm = mm('(prefers-reduced-motion: reduce)');
    if (mm('(min-width: 990px)')) {
      finder.scrollIntoView({ block: 'start', behavior: calm ? 'auto' : 'smooth' });
      if (mm('(hover: hover) and (pointer: fine)')) setTimeout(function () { input.focus({ preventScroll: true }); input.select(); }, 320);
      return;
    }
    seq++; current = null;
    input.value = ''; activeType = '';
    Array.prototype.forEach.call(types.children, function (c) { var on = !c.getAttribute('data-type'); c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    if (chips) Array.prototype.forEach.call(chips.querySelectorAll('.svnty-sg__chip'), function (c) { c.setAttribute('aria-pressed', 'false'); });
    render('');
    var end = function () { stage.classList.remove('is-leaving', 'is-shut'); stage.style.height = ''; mount.innerHTML = ''; cardRail.innerHTML = ''; showLoading(false); errorEl.hidden = true; };
    if (!calm) { stage.style.height = stage.offsetHeight + 'px'; stage.classList.add('is-leaving'); }
    root.classList.remove('is-staged');   /* the finder takes its own place at once; the leaving stage keeps its box while it folds */
    if (calm) end();
    else { void stage.offsetHeight; requestAnimationFrame(function () { stage.classList.add('is-shut'); stage.style.height = '0px'; }); setTimeout(end, 360); }
    /* the finder under the header as it will stand: a scroll that goes up brings the announcement bar back */
    var de = document.documentElement, cs = getComputedStyle(de), now = parseFloat(cs.getPropertyValue('--svnty-headstack-h')) || 98, bar = parseFloat(cs.getPropertyValue('--svnty-ann-h')) || 0;
    var slab = de.classList.contains('svnty-bar-hidden') ? now + bar : now;
    window.scrollTo({ top: Math.max(0, window.scrollY + finder.getBoundingClientRect().top - slab - 16), behavior: calm ? 'auto' : 'smooth' });
    var h = finder.querySelector('.svnty-sg__h2'); if (h) { h.setAttribute('tabindex', '-1'); try { h.focus({ preventScroll: true }); } catch (e) {} }
  });

  /* ------------------------------------------------------------ start: a deep link opens its piece; else the catalog warms on idle */
  var wanted = null;
  try { wanted = new URL(location.href).searchParams.get('product'); } catch (e) {}
  var deskDefault = root.getAttribute('data-default') || '';
  /* P22-21: a reload, a Back or a Forward brings back what she typed, and her place on a staged piece; a fresh visit opens clean */
  var navType = '';
  try { navType = ((performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {}).type || ''; } catch (e) {}
  var returning = navType === 'reload' || navType === 'back_forward';
  window.addEventListener('pagehide', function () { keep(PLACE, { u: location.pathname + location.search, y: Math.round(window.scrollY), t: Date.now() }); });
  if (returning) {
    var f = kept(FIND);
    if (f) {
      input.value = f.q || ''; activeType = f.ty || '';
      Array.prototype.forEach.call(types.children, function (c) { var on = (c.getAttribute('data-type') || '') === activeType; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      render(input.value);
    }
    var pl = kept(PLACE);
    if (wanted && pl && pl.u === location.pathname + location.search) {
      place = pl.y;
      try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}
      setTimeout(function () { settle(true); }, 4000);
    }
  }
  if (wanted) pick(wanted);
  else if (deskDefault && window.matchMedia && window.matchMedia('(min-width: 990px)').matches) pick(deskDefault, true);   /* THE DESK'S FIRST VIEW */
  else loadCatalog();
  /* P17-27 (refuter R2 P2-1): the desk's stage shows from 990 px, so an iPad turned from portrait to landscape (or a window widened
     past 990) held the skeleton for ever: the first pick ran once, at load. The query now stages the default the moment the
     desk's layout arrives, unless she already staged a piece. */
  if (deskDefault && window.matchMedia) {
    var deskMQ = window.matchMedia('(min-width: 990px)');
    var onDesk = function (e) { if (e.matches && !root.classList.contains('is-staged')) pick(deskDefault, true); };
    if (deskMQ.addEventListener) deskMQ.addEventListener('change', onDesk); else if (deskMQ.addListener) deskMQ.addListener(onDesk);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["svnty-wishlist"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var root = document.querySelector('[data-svnty-wl2]');
  if (!root) return;
  var grid = root.querySelector('[data-wl2-grid]'), empty = root.querySelector('[data-wl2-empty]'), share = root.querySelector('[data-svnty-wl-share]'), line = root.querySelector('[data-wl2-line]');
  var base = root.getAttribute('data-fetch-base') || '/'; if (base.charAt(base.length - 1) !== '/') base += '/';
  var UNDO_MS = parseInt(root.getAttribute('data-undo-ms'), 10) || 5000;
  var lineWords = '';
  var cards = {}, pending = {}, gone = {};
  var W = window.SVNTY && window.SVNTY.wl2;   /* the first paint's reader and words (the inline script under the markup) */
  if (!W) return;
  function str(v) { return v == null ? '' : String(v); }
  var key = W.key, read = W.read;
  lineWords = W.line0 != null ? W.line0 : (line ? line.textContent : '');
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fetchCard(it) {
    var k = key(it);
    if (cards[k]) return Promise.resolve(cards[k]);
    if (pending[k]) return pending[k];
    var vid = str(it.vid) || ((/[?&]variant=(\d+)/.exec(str(it.url)) || [])[1] || '');
    pending[k] = fetch(base + 'products/' + encodeURIComponent(str(it.handle)) + '?' + (vid ? 'variant=' + vid + '&' : '') + 'section_id=svnty-card-fetch', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (txt) {
        var li = txt && new DOMParser().parseFromString(txt, 'text/html').querySelector('li[data-svnty-card-fetch]');
        if (!li) return null;
        var pid = li.getAttribute('data-svnty-fetch-pid') || '';
        Array.prototype.forEach.call(li.querySelectorAll('link[rel="stylesheet"]'), function (l) { if (document.querySelector('link[href="' + l.getAttribute('href') + '"]')) l.remove(); });
        var html = li.outerHTML;
        if (pid) html = html.split('recent-' + pid).join('wl-' + k + '-' + pid).split('recent' + pid).join('wl' + k + pid);
        var box = document.createElement('div'); box.innerHTML = html; var el = box.firstElementChild;
        el.setAttribute('data-wl2-key', k);
        cards[k] = el; return el;
      })
      .catch(function () { return null; })
      .then(function (el) { delete pending[k]; return el; });
    return pending[k];
  }
  function cell(k) { return grid.querySelector('[data-wl2-key="' + k.replace(/"/g, '') + '"]'); }
  function words(n) {
    if (!line) return;
    var t = n === 0 ? lineWords : W.words(n);
    if (line.textContent !== t) line.textContent = t;
  }
  function render(items, changed) {
    var keys = items.map(key), seen = {};
    keys.forEach(function (k) { seen[k] = 1; });
    /* what left: with Undo when a heart did it just now, at once on a fresh paint */
    Array.prototype.slice.call(grid.children).forEach(function (li) {
      var k = li.getAttribute('data-wl2-key');
      if (seen[k]) { if (gone[k]) { clearTimeout(gone[k]); delete gone[k]; li.classList.remove('is-gone'); var u = li.querySelector('.svnty-wl2__undo'); if (u) u.remove(); } return; }
      if (!changed || gone[k]) { if (!gone[k]) li.remove(); return; }
      li.classList.add('is-gone');
      var undo = document.createElement('div'); undo.className = 'svnty-wl2__undo'; undo.setAttribute('role', 'status');
      undo.innerHTML = '<span>Removed</span><button type="button" class="svnty-wl2__undo-btn" data-wl2-undo>Undo</button>';
      li.appendChild(undo);
      gone[k] = setTimeout(function () { delete gone[k]; li.remove(); sync(); }, UNDO_MS);
    });
    /* what is here, in the store's order (newest first). P17-16 (eye pass A P1-2): a piece that just left keeps its cell for its
       Undo, so the walk steps over gone cells instead of re-anchoring every piece from the grid's start (which moved the gone
       one to the end and slid the others under the finger). A placeholder seated by the first paint is fetched in place. */
    var anchor = null;
    keys.forEach(function (k, i) {
      var it = items[i], li = cell(k);
      if (!li) li = W.skeleton(k);
      if (li.classList.contains('svnty-wl2__skel') && !li.__wl2Fetch) {
        li.__wl2Fetch = true;
        fetchCard(it).then(function (el) { var cur = cell(k); if (!el) { if (cur) cur.remove(); sync(); return; } if (cur && cur !== el && cur.parentNode === grid) grid.replaceChild(el, cur); });
      }
      var next = anchor ? anchor.nextSibling : grid.firstChild;
      while (next && next !== li && next.classList && next.classList.contains('is-gone')) next = next.nextSibling;
      if (next !== li) grid.insertBefore(li, next);
      anchor = li;
    });
    grid.setAttribute('aria-busy', 'false');
    sync(items.length);
  }
  function sync(n) {
    if (typeof n !== 'number') n = grid.querySelectorAll('[data-wl2-key]:not(.is-gone)').length;
    var none = n === 0;
    if (empty && empty.hidden !== !none) empty.hidden = !none;
    var gh = none && !grid.querySelector('.is-gone');
    if (grid.hidden !== gh) grid.hidden = gh;
    if (share && share.hidden !== none) share.hidden = none;
    words(n);
  }
  grid.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-wl2-undo]'); if (!b) return;
    var li = b.closest('[data-wl2-key]'), heart = li && li.querySelector('.svnty-heart__btn');
    if (heart) heart.click();
  });
  document.addEventListener('svnty:wishlist:change', function () { render(read(), true); });
  render(read(), false);
})();

  } catch(e) { console.error(e); }
})();
})();
